// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:02.798Z
// Property: Cherry Hill Towers (ID: 6767906449166312)
// Collections: 38 amenities, 36 floorplans (live), 37 photos, 79 POIs, 1 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166312",
  "property_external_id": "30949",
  "property_zillow_url": "https://www.zillow.com/apartments/cherry-hill-township-nj/cherry-hill-towers/5XkKh7/",
  "property_apartments_url": "https://www.apartments.com/cherry-hill-towers-cherry-hill-nj/ceg751f/",
  "property_google_business_url": "https://www.google.com/maps/place/Cherry+Hill+Towers+Apartment+Homes/data=!4m2!3m1!1s0x0:0x406b22d09a9c30df?sa=X&ved=2ahUKEwiI9vKkkriSAxXlAHkGHaEoAU4Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cherry-hill-towers",
  "property_name": "Cherry Hill Towers",
  "property_website_url": "https://www.livecherryhilltowers.com/",
  "property_domain": "https://www.livecherryhilltowers.com/",
  "property_address": "2145 New Jersey 38",
  "property_full_address": "2145 NJ-38, Cherry Hill Township, NJ 08002",
  "property_address_1": "2145 NJ-38",
  "property_address_2": null,
  "property_address_city": "Cherry Hill Township",
  "property_address_state": "NJ",
  "property_address_zip_full": "08002-4285",
  "property_address_zip": "08002",
  "property_address_country": "US",
  "property_address_county": "Camden County",
  "property_neighborhood_address": "Cherry Hill Mall",
  "property_address_latitude": "39.9383028",
  "property_address_longitude": "-75.0205898",
  "property_email": "cherryhilltowers@aionmanagement.com",
  "property_phone": "(856) 661-0020",
  "property_call_tracking_phone": "888-835-2962",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cherry Hill Towers, where modern living meets nature's tranquility. Enjoy spacious one and two-bedroom floor plans alongside premium amenities, including a refreshing swimming pool, vibrant clubhouse, and scenic walking trails. Embrace a lifestyle of convenience and comfort in our pet-friendly community—your ideal home awaits!",
  "property_long_description": "<p>This is elevated, iconic living in Camden County. The city is all around you when you live at Cherry Hill Towers. You’ll be living just steps from incredible dining destinations, entertainment hotspots, a buzzing nightlife scene, and pretty much anything else you’d want to experience. When you’re not living life to the max in an energetic area, you’ll be back at our luxe amenity spaces hanging out and making friends. With our high-end, upgraded one, two, and three bedroom apartment homes, you’ll be further treated to opening your front door to a pet-friendly luxurious retreat. So, welcome home. This is Cherry Hill Towers.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-26af-715e-96de-6e6d09686ac8.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style pool and lounge area with a modern apartment building in the background.",
    "public_id": "019fd955-26af-715e-96de-6e6d09686ac8",
    "storage_key": "property/6767906449166312/019fd955-26af-715e-96de-6e6d09686ac8.webp",
    "width": 1920,
    "height": 1015
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "434",
  "property_year_built": "1962",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.7741935483871",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow dogs, cats, and service animals. All must be housebroken; no breeding allowed. Breed restrictions apply (e.g., German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans, Rottweilers, wolf-dog hybrids, Pit Bulls, Presa Canarios, etc.). Maximum of 2 pets per unit.",
  "property_pet_policy_description": "We love pets and happily welcome dogs, cats, and service animals to our community. Breed restrictions apply; please contact the leasing office for details. A one-time, non-refundable pet fee of $350 is due at move-in, and monthly pet rent is $50 per pet. We allow up to 2 pets per home, and there are no weight restrictions. Contact our team today to learn more about our pet policy and schedule a tour to see our pet-friendly community in Cherry Hill, New Jersey.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://cherryhilltowers.loftliving.com/login",
  "property_apply_now_url": "https://www.livecherryhilltowers.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0264-8698-751e-9f4b-df5e44bc14fc.webp",
  "property_primary_logo_media": {
    "alt_text": "Cherry Hill Towers logo",
    "public_id": "019d0264-8698-751e-9f4b-df5e44bc14fc",
    "storage_key": "property/6767906449166312/019d0264-8698-751e-9f4b-df5e44bc14fc.webp",
    "width": 1848,
    "height": 855
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-2728-7347-9b69-fc961a32bfeb.webp",
  "property_secondary_logo_media": {
    "alt_text": "AI ON Management logo",
    "public_id": "019d0268-2728-7347-9b69-fc961a32bfeb",
    "storage_key": "property/6767906449166312/019d0268-2728-7347-9b69-fc961a32bfeb.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-31e4-75fc-b38c-38e712138cb0.webp",
  "property_icon_media": {
    "alt_text": "CH logo",
    "public_id": "019d0268-31e4-75fc-b38c-38e712138cb0",
    "storage_key": "property/6767906449166312/019d0268-31e4-75fc-b38c-38e712138cb0.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019faefd-e328-71be-8b75-b3564384842c.webp",
  "property_fav_icon_media": {
    "alt_text": "Avanti Residential logo.",
    "public_id": "019faefd-e328-71be-8b75-b3564384842c",
    "storage_key": "property/6767906449166312/019faefd-e328-71be-8b75-b3564384842c.webp",
    "width": 256,
    "height": 256
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-4da2-7236-9f80-c5505975623c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cherry Hill Towers logo",
    "public_id": "019d0268-4da2-7236-9f80-c5505975623c",
    "storage_key": "property/6767906449166312/019d0268-4da2-7236-9f80-c5505975623c.webp",
    "width": 640,
    "height": 296
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-58e9-7769-892a-6e148bfec01b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cherry Hill Towers logo",
    "public_id": "019d0268-58e9-7769-892a-6e148bfec01b",
    "storage_key": "property/6767906449166312/019d0268-58e9-7769-892a-6e148bfec01b.webp",
    "width": 640,
    "height": 296
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#e2903d",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "689 - 1197",
  "property_sqft_min": "689",
  "property_sqft_max": "1197",
  "property_price_range": "1674 - 2553",
  "property_price_min": "1674",
  "property_price_max": "2553",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/cherryhilltowers",
  "property_instagram_url": "https://www.instagram.com/cherryhilltowersapts",
  "property_twitter_url": "https://www.twitter.com/cherryhilltower",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcURImKzLxokR3zCcmtAia0A",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cherry-hill-towers-apartment-homes-cherry-hill",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cherry Hill Towers",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Cherry Hill Towers, where modern living meets nature’s tranquility. Choose from stylish one or two-bedroom floor plans, and indulge in amenities like a sparkling swimming pool, scenic walking trails, and a vibrant pet-friendly atmosphere. Elevate your lifestyle today and experience the perfect blend of comfort and convenience!",
  "property_home_floorplans_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, your ideal living space awaits. Enjoy a harmonious blend of comfort and style with our thoughtfully designed one and two-bedroom apartment homes. Browse our available options to uncover the perfect layout that suits your lifestyle and elevates everyday living.",
  "property_home_gallery_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, life comes with a blend of comfort and convenience. Enjoy spacious one- and two-bedroom floor plans paired with extraordinary amenities—including a sparkling pool, pet-friendly spaces, and vibrant resident activities. Picture yourself lounging by the fire pit or exploring scenic walking trails.",
  "property_home_neighborhood_blurb": "Welcome to Cherry Hill Towers, where modern living meets vibrant community life. Nestled in Cherry Hill Township, our one- and two-bedroom apartments place you within reach of cultural gems like the Barclay Farmstead Museum and the Adventure Aquarium. Dive into local favorites and discover the heartbeat of your new home!",
  "property_home_reviews_blurb": "At Cherry Hill Towers, residents rave about our attentive team and stunning amenities. One happy tenant shared, \"Cait goes above and beyond! We love living here!\" Experience spacious, modern living alongside impeccable service in a prime location near shopping and dining. Find your perfect home today!",
  "property_neighborhood_blurb": "Experience the vibrant lifestyle at Cherry Hill Towers, located in the heart of Cherry Hill Township. Enjoy nearby attractions like the Barclay Farmstead Museum, Cooper River Park, and the adventure-filled Camden Children's Garden. Whether basking in nature or exploring cultural gems, your perfect one or two-bedroom home awaits in this thriving community.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cherry Hill Towers, enjoy a vibrant lifestyle with diverse floor plans from one to two bedrooms, complemented by a wealth of amenities. Savor sunny days at our outdoor lounge, engage with neighbors in the game room, or unwind by the fire pit. Convenience and comfort await in Cherry Hill Township, NJ!",
  "property_applynow_blurb": "At Cherry Hill Towers, you’ll find a serene blend of modern comfort and vibrant community living in Cherry Hill Township, NJ. Enjoy spacious one and two-bedroom floor plans, resort-style amenities, and picturesque walking trails. Embrace an active lifestyle with our fitness center, dog park, and outdoor lounge. Lease your new home online today!",
  "property_contactus_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, your perfect home awaits! Choose from stylish one-bedroom and spacious two-bedroom floor plans designed for comfort and convenience. Whether you're downsizing or seeking more space, our leasing team is here to help. Have questions? Contact us today!",
  "property_faqs_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, find your perfect home—whether it’s a cozy one-bedroom retreat or a spacious two-bedroom haven. Uncover everything you need to know about our vibrant community by visiting our FAQs page for insightful answers tailored just for you.",
  "property_floorplans_blurb": "At Cherry Hill Towers, we offer thoughtfully designed floor plans that cater to your lifestyle. Choose from our spacious one-bedroom retreats or inviting two-bedroom homes in the heart of Cherry Hill Township, NJ. Browse our available apartment options to find the perfect layout that suits your needs!",
  "property_gallery_blurb": "At Cherry Hill Towers, elevate your lifestyle in our beautifully designed high-rise apartments, complete with stunning views and modern amenities. Enjoy leisurely strolls along walking trails, entertain friends at our outdoor grilling stations, or unwind in the luxurious resident lounge. Picture yourself living here, where comfort meets community in Cherry Hill Township, NJ!",
  "property_interactivemap_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, choose from thoughtfully designed one and two-bedroom apartments featuring amenities like a sparkling pool, pet-friendly dog park, and vibrant resident activities. Our interactive community map makes finding your perfect home effortless. Dive into elevated living today!",
  "property_pets_blurb": "At Cherry Hill Towers, your furry friends will feel right at home! With a welcoming pet policy, our community offers a cozy retreat for dogs and cats, provided they’re housebroken. Enjoy life together amid beautiful surroundings in Cherry Hill Township, NJ—where comfort meets convenience for you and your pets!",
  "property_referafriend_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, our diverse floor plans, including cozy one-bedroom and spacious two-bedroom apartments, cater to every lifestyle. Share the joy of community living—refer a friend today and turn neighbors into lifelong friends! Experience the charm of Cherry Hill together.",
  "property_residentaccess_blurb": "Welcome to Cherry Hill Towers in Cherry Hill Township, NJ, where comfort meets style! With spacious one and two-bedroom floor plans tailored to your lifestyle, managing your home is effortless. Access your resident portal today to pay rent, schedule maintenance, and enjoy a seamless living experience!",
  "property_reviews_blurb": "At Cherry Hill Towers, residents rave about our dedicated staff and exceptional living experience. \"Cait goes above and beyond! She genuinely cares about residents and my family!\" With beautiful grounds, modern upgrades, and an array of amenities, our community feels more like a luxury condo than an apartment complex.",
  "property_created_at": "1757004855057",
  "property_scheduletour_blurb": "At Cherry Hill Towers in Cherry Hill Township, NJ, your ideal living space awaits. Choose from stylish one- and two-bedroom apartments designed for comfort and convenience. Ready to envision your new home? Schedule a tour today and see what our residents love about life in our vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Cherry Hill Towers in beautiful Cherry Hill Township, NJ! Our stylish one and two-bedroom floor plans offer a perfect blend of comfort and elegance, tailored to your lifestyle. Keep an eye on your inbox—our team will connect with you soon to discuss your future home!",
  "property_virtualtours_blurb": "Step into Cherry Hill Towers, where modern living meets comfort in Cherry Hill Township, NJ. Choose from thoughtfully designed one and two-bedroom apartments that suit your lifestyle. Immerse yourself in our vibrant community by taking a virtual tour today—your perfect home awaits!",
  "property_copyright": "2025 All Rights Reserved. Cherry Hill Towers",
  "property_seo_title_home": "Cherry Hill Towers |  Apartments in Cherry Hill Township, NJ",
  "property_seo_description_home": "Experience modern living at Cherry Hill Towers! Enjoy upscale amenities, stunning views, and a vibrant community in your ideal home!",
  "property_seo_title_floorplans": "Floor Plans | Cherry Hill Township, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cherry Hill Towers in NJ. Choose from spacious one or two-bedroom floor plans designed for comfort. Browse to secure your dream space!",
  "property_seo_title_amenities": "Amenities | Cherry Hill Township, NJ Apartments for Rent",
  "property_seo_description_amenities": "Experience Cherry Hill Towers, where luxury meets comfort! Enjoy stunning floor plans, premium amenities like a pool, fitness center, and pet-friendly spaces.",
  "property_seo_title_gallery": "Gallery | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_gallery": "Experience life at Cherry Hill Towers! Enjoy modern living with stunning floor plans, top-notch amenities, and a vibrant community in Cherry Hill Township, NJ.",
  "property_seo_title_virtualtours": "Virtual Tours | Cherry Hill Towers Apartments",
  "property_seo_description_virtualtours": "Step into Cherry Hill Towers in picturesque Cherry Hill Township, NJ. Experience spacious one and two-bedroom apartments with our immersive virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Cherry Hill Towers Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Cherry Hill Towers! Enjoy stunning views, top amenities, and a vibrant community. Your new life awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_neighborhood": "Uncover the charm of Cherry Hill Towers! Nestled in Cherry Hill Township, NJ, explore local gems and vibrant points of interest just outside your door.",
  "property_seo_title_contact": "Contact Us | Cherry Hill Towers",
  "property_seo_description_contact": "Connect with Cherry Hill Towers in Cherry Hill Township, NJ! Inquire about our spacious one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_faqs": "Uncover answers at Cherry Hill Towers! From pet-friendly perks to on-site amenities, our FAQs guide you through life in beautiful Cherry Hill Township, NJ.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_reviews": "\"Discover life at Cherry Hill Towers, NJ! Enjoy modern amenities, scenic trails, and vibrant activities. See why residents love it here!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_applynow": "Elevate your lifestyle at Cherry Hill Towers! Enjoy modern amenities, beautiful floor plans, and endless activities. Secure your new home in NJ today!",
  "property_seo_title_residentaccess": "Resident Access | Cherry Hill Towers",
  "property_seo_description_residentaccess": "Log in to Cherry Hill Towers' portal for easy rent payments, maintenance requests, and updates. Your new home in Cherry Hill Township awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Cherry Hill Towers",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Cherry Hill Towers and share the joy of community living in Cherry Hill Township, NJ today.",
  "property_seo_title_scheduletour": "Schedule a Tour | Cherry Hill Towers",
  "property_seo_description_scheduletour": "Experience the charm of Cherry Hill Towers in Cherry Hill Township, NJ. Schedule your tour today and find your perfect home amidst serene surroundings!",
  "property_seo_title_privacy": "Privacy Policy | Cherry Hill Towers",
  "property_seo_description_privacy": "At Cherry Hill Towers, your privacy matters. Learn how we protect your information in Cherry Hill Township, NJ. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Cherry Hill Towers",
  "property_seo_description_accessibility": "Enhance your experience at Cherry Hill Towers! Our accessibility statement promotes inclusivity for all residents in Cherry Hill Township, NJ.",
  "property_seo_title_sitemap": "Sitemap | Cherry Hill Towers",
  "property_seo_description_sitemap": "Navigate your way through Cherry Hill Towers! Find every detail about our vibrant community in Cherry Hill Township, NJ. Check out our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Cherry Hill Towers",
  "property_seo_description_thankyou": "Thanks for reaching out! Your journey to vibrant living at Cherry Hill Towers starts here. Our team will be in touch soon about your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Cherry Hill Township, NJ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293670302",
  "amenities": [
    {
      "id": "custom_7fbe00c2-8f2d-4783-9514-7db585cf41d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff5816b0-2f05-46ac-9f9c-29ad0cc45578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26cb35a0-04b2-4cbf-86d3-caaad29fb67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Bilingual Site Team",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93322b70-5928-4736-aba9-958c6739940b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_122cb302-b665-44d7-ba67-00236bcf8869",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Resident Lounge",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c264a0b-2076-4561-948e-616a693214f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Buildings & Parking",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93cb1648-2f98-4a28-b4bc-bacf64d5a292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_877b8cce-0634-4411-bd72-d85a7020f11a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_588b91a7-f0dd-4ef4-9ad1-76fd380e2cc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests & Rent Payment",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66c7f1e9-2cd3-4efc-8ff9-585ec6dfa670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Package Room",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d65ef6c5-5c5e-4d25-87f6-6519b49965ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a70d025f-5312-4747-a816-4ff537b5e2b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4d250c0-1f25-43d2-81c4-4abb01e7383e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bcf0a1ce-4821-4fce-8b54-b6bdc1cea994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a61b869-9aa3-4965-9db8-beea45f4db18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Built In Microwave",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d9921da-a7d9-40df-af6d-30f30a6d4e47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52ccef92-7bd5-4c4f-b41d-4b895a796d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a938095a-0f1a-4903-8e09-d87a2782d868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood-like Vinyl Plank Flooring*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2de694e9-0b26-45e0-a9d7-209840eb63b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94adfcf1-52f1-4a4f-b9c4-5fc02e3f42bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens & Baths",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4f0655c-9b60-4c60-bb06-26147fb622ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6de790c8-bbdd-4558-8594-7c05d5edf5ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer In-Unit",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2f00930-355d-49a1-94a0-43e14751522f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Cherry Hill School District",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7c9084e-1847-4802-9789-a620bd63d646",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Directly Across from Cherry Hill Mall",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58a6955b-a656-40c7-8246-94009ae1fc8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to I-295, NJ Turnpike & Highways 70, 73, and 41",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_423a95ed-11cf-427d-836a-ada11769fbf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Patco Station to Center City Philadelphia less than 5 miles away",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74fa887f-67c6-40b3-9af6-2233b9558312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6f7bee3-11c2-4436-ab5b-66c274e671ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Walking & Biking Trails",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_445c18c9-8c4c-4ac8-b459-ac9849f2d5b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Picnic Pavillion",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cc99efb-0a74-4e16-b4e0-991e5e7dd8f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cca0aef1-ac7d-4199-93b8-44671f080241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Station",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3dd15121-67c9-459d-82ea-85dd33106e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Lighted Tennis Court",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6ab0994-fcd7-4fb3-908c-a4247e588176",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge with Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f616f02e-9b97-4382-b965-b1ba9418b771",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Pickleball Courts",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b09f1ed6-b2b4-46a2-9021-be8d9dcf0d08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50a75d89-fa77-4cf8-a23a-7b9ba59a1e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Putting Green",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f638131-6c67-4dec-bc1b-e880e5bf8eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe2ab24d-059e-48c5-8fa8-d7e1c01474a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c0191647-011a-4444-af53-82c19fd6b314",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-eb37-716d-88ed-dce6cf191e47.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and quartz countertops.",
        "public_id": "019fd955-eb37-716d-88ed-dce6cf191e47",
        "storage_key": "property/6767906449166312/019fd955-eb37-716d-88ed-dce6cf191e47.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen with white cabinets, marble-like counters, and stainless steel appliances.",
      "link": "false",
      "alt_text": "White kitchen with stainless steel stove, microwave, sink, and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/a6e3ed6129432e1e32cd12e20092d3d8-1920w.jpg"
    },
    {
      "id": "custom_4692d20d-3943-437e-9362-f3ba25135582",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-eb7d-745d-a5ff-da7170a8c5e1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019fd955-eb7d-745d-a5ff-da7170a8c5e1",
        "storage_key": "property/6767906449166312/019fd955-eb7d-745d-a5ff-da7170a8c5e1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A bright and spacious kitchen featuring sleek white cabinetry, durable quartz countertops, and a stylish subway tile backsplash. Equipped with modern stainless steel appliances, this kitchen is perfect for any home chef.",
      "link": "false",
      "alt_text": "Bright white galley kitchen with stainless appliances and a view to a hallway and windowed door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-4-1920w.jpg"
    },
    {
      "id": "custom_a50bca7a-1b36-45f6-82c5-1c777e13d626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-ebbf-7774-98ad-f58b0648bbf5.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a large window and modern furniture.",
        "public_id": "019fd955-ebbf-7774-98ad-f58b0648bbf5",
        "storage_key": "property/6767906449166312/019fd955-ebbf-7774-98ad-f58b0648bbf5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright open-concept living and dining room with light wood floors, white walls, and modern furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry_Hill_Towers_7.18.26_Cherry_Hill_Towers_POI-1_18-07-26_21_54-1920w.jpeg"
    },
    {
      "id": "custom_0eb39fd1-7e8b-4915-85b1-66a1522c0ca3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-eb36-7604-9f8e-fb36d0c94e46.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, large closet, and a plant.",
        "public_id": "019fd955-eb36-7604-9f8e-fb36d0c94e46",
        "storage_key": "property/6767906449166312/019fd955-eb36-7604-9f8e-fb36d0c94e46.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright modern bedroom with a white bed, green pillow, gray throw, and open closet and bathroom doors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry_Hill_Towers_7.18.26_Cherry_Hill_Towers_POI-6_18-07-26_21_56-1920w.jpeg"
    },
    {
      "id": "custom_13810c20-1a20-41f7-a323-9744e77104e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-f6de-742f-b4a8-4fca728fb165.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a white platform bed, green and gray bedding, and a large window with a view of trees.",
        "public_id": "019fd955-f6de-742f-b4a8-4fca728fb165",
        "storage_key": "property/6767906449166312/019fd955-f6de-742f-b4a8-4fca728fb165.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a comfortable bed, plush carpeting, and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bright bedroom with a bed, two nightstands, and a large window with a view outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry_Hill_Towers_7.18.26_Cherry_Hill_Towers_POI-2_18-07-26_22_21-1920w.jpeg"
    },
    {
      "id": "custom_b2465973-b26d-49ab-a226-975e0201239a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-f6f9-701d-b0fb-5a5431b2d1bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fd955-f6f9-701d-b0fb-5a5431b2d1bb",
        "storage_key": "property/6767906449166312/019fd955-f6f9-701d-b0fb-5a5431b2d1bb.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with white cabinetry, granite countertops, subway tile backsplash, and stainless steel appliances.",
      "link": "false",
      "alt_text": "U-shaped kitchen with white raised-panel cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/efc2fecd54178702d42a3d8a93f04e94-1920w.webp"
    },
    {
      "id": "custom_ffbad50a-93c3-499a-9c93-e68327a1bcb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-f754-71ed-ac9c-f1aecb12ba5c.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, entertainment center, and decor.",
        "public_id": "019fd955-f754-71ed-ac9c-f1aecb12ba5c",
        "storage_key": "property/6767906449166312/019fd955-f754-71ed-ac9c-f1aecb12ba5c.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a beige sofa, dark wood floor, shelves, and a large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/3037b4815dc06ecf09ac0dc58c7f9d80-1920w.jpg"
    },
    {
      "id": "custom_03c7f065-21b6-411a-bdd7-72bcddf94bf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-f79b-7388-b499-73e1dd890e03.webp",
      "image_media": {
        "alt_text": "Stylish living room with a large sectional sofa, decorative pillows, and a coffee table.",
        "public_id": "019fd955-f79b-7388-b499-73e1dd890e03",
        "storage_key": "property/6767906449166312/019fd955-f79b-7388-b499-73e1dd890e03.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "Bright living space in a stylish apartment featuring neutral decor, a plush beige sofa, and modern accents.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with beige sofa, decorative cushions, and window blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/f5c75df283b882577e0aed57bcd51b08-1920w.jpg"
    },
    {
      "id": "custom_26bece31-066a-47be-bdb7-274aeba21adf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0140-7510-a4df-1fd0d2f5be62.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, modern dresser with TV, armchair, and a large window.",
        "public_id": "019fd956-0140-7510-a4df-1fd0d2f5be62",
        "storage_key": "property/6767906449166312/019fd956-0140-7510-a4df-1fd0d2f5be62.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Bright contemporary bedroom in a modern apartment featuring a bed, a wooden dresser, a bookshelf, and a large window with a view.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, dresser, bookshelf, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/8b96f5cedb2d61eaeeadb8bd859ce8e8-1920w.webp"
    },
    {
      "id": "custom_619210c9-f9e9-434b-8d7a-9fef01c9e6f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0196-74ba-908a-e7772739cf23.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and oven in a modern kitchen with white cabinets and countertops.",
        "public_id": "019fd956-0196-74ba-908a-e7772739cf23",
        "storage_key": "property/6767906449166312/019fd956-0196-74ba-908a-e7772739cf23.webp",
        "width": 1280,
        "height": 851
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless steel fridge, dishwasher, and oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/833ed33c4db4b094ba6bd02e9af99457-1920w.jpg"
    },
    {
      "id": "custom_beec5b8e-3132-4906-a7b5-0304afa68a2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-01e2-7424-95eb-75f8359a5b33.webp",
      "image_media": {
        "alt_text": "Dining area with a round marble-top table and four upholstered chairs.",
        "public_id": "019fd956-01e2-7424-95eb-75f8359a5b33",
        "storage_key": "property/6767906449166312/019fd956-01e2-7424-95eb-75f8359a5b33.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "A beautifully appointed dining area, perfect for intimate meals or entertaining guests. Features a round marble-top table, elegant upholstered chairs, and stylish decor.",
      "link": "false",
      "alt_text": "Round marble dining table with four gray upholstered chairs in a bright dining nook by a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/ebd437f54c86dcd666f8efc049d7017b-1920w.webp"
    },
    {
      "id": "custom_08ac1af5-156b-4563-9a1c-f508b3991c10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-01de-7780-ad34-3475b82f3e92.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, closet, and an open doorway leading to the kitchen area.",
        "public_id": "019fd956-01de-7780-ad34-3475b82f3e92",
        "storage_key": "property/6767906449166312/019fd956-01de-7780-ad34-3475b82f3e92.webp",
        "width": 1280,
        "height": 966
      },
      "title": "Apartment",
      "description": "Contemporary apartment bedroom with neutral tones, a dresser, and a view into the adjacent kitchen/hallway.",
      "link": "false",
      "alt_text": "Bedroom with a neatly made bed, beige bedding, dresser with decor, and an open doorway to a hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/cc2eac79a06539a411948e031ada1956-1920w.jpg"
    },
    {
      "id": "custom_0dbe5bb3-03be-4617-802d-e96761f3c7ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0afc-724e-8c13-62348de26c2d.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table.",
        "public_id": "019fd956-0afc-724e-8c13-62348de26c2d",
        "storage_key": "property/6767906449166312/019fd956-0afc-724e-8c13-62348de26c2d.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Open-concept living area with dining table, couch seating, and a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/9ae2fdef53e2d2aae765b5895eec05ad-1920w.webp"
    },
    {
      "id": "custom_692cd0a9-b0a0-45a4-8e77-a4ca3c9b5a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0c3d-70f8-8050-4dd1d554d176.webp",
      "image_media": {
        "alt_text": "Bedroom with large window, dresser, and armchair.",
        "public_id": "019fd956-0c3d-70f8-8050-4dd1d554d176",
        "storage_key": "property/6767906449166312/019fd956-0c3d-70f8-8050-4dd1d554d176.webp",
        "width": 1280,
        "height": 850
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment bedroom with neutral tones, a low dresser, seating area, and expansive natural light.",
      "link": "false",
      "alt_text": "Modern bedroom in a light-filled apartment with a low wood dresser, chair, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/a62ff62766879778b3e474fe2d7bab6c-1920w.jpg"
    },
    {
      "id": "custom_2e51e347-d153-4729-bbed-6d8c8b2c8095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0c5c-7094-8f6d-4874cf9cfe33.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fd956-0c5c-7094-8f6d-4874cf9cfe33",
        "storage_key": "property/6767906449166312/019fd956-0c5c-7094-8f6d-4874cf9cfe33.webp",
        "width": 1280,
        "height": 967
      },
      "title": "Apartment",
      "description": "Spacious galley-style kitchen in a modern apartment, featuring granite countertops, white cabinetry, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Apartment kitchen with white cabinets, granite counters, stainless steel appliances, and a view of the living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/059d1b71068156007d08104c66466fad-1920w.webp"
    },
    {
      "id": "custom_2a7556f1-76a0-4fe8-84d3-c16767459a77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-0cb6-73db-ab35-8fbdd5158177.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, desk, and window.",
        "public_id": "019fd956-0cb6-73db-ab35-8fbdd5158177",
        "storage_key": "property/6767906449166312/019fd956-0cb6-73db-ab35-8fbdd5158177.webp",
        "width": 1280,
        "height": 966
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a dedicated workspace with a desk and bookshelf, and a large window for natural light.",
      "link": "false",
      "alt_text": "Bright modern bedroom in an apartment with a bed, desk, chair, dresser, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/ea4746f84cd7c52ad996d5361413e2c8-1920w.jpg"
    },
    {
      "id": "custom_f8607605-ffbf-4d5d-8ba1-6735e1927f2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-162a-761a-8007-1ace0fbadb76.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and bathtub.",
        "public_id": "019fd956-162a-761a-8007-1ace0fbadb76",
        "storage_key": "property/6767906449166312/019fd956-162a-761a-8007-1ace0fbadb76.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in this modern bathroom featuring a clean white vanity, a spacious bathtub, and ample lighting.",
      "link": "false",
      "alt_text": "Bright modern bathroom with white vanity, large mirror, and tiled tub/shower area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry_Hill_Towers_7.18.26_Cherry_Hill_Towers_POI-7_18-07-26_21_37-1920w.jpg"
    },
    {
      "id": "custom_a8426f37-0fed-4f16-96fd-3dbfd8cfcf6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-1683-716f-a02a-249f5d02db54.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit in a hallway with a white door.",
        "public_id": "019fd956-1683-716f-a02a-249f5d02db54",
        "storage_key": "property/6767906449166312/019fd956-1683-716f-a02a-249f5d02db54.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Laundry room with stacked washer and dryer, beige tile floor, gray walls, and white door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-5-1920w.jpg"
    },
    {
      "id": "custom_ca39b6ea-a049-4627-8132-825dc890cde1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-16ea-73b0-8648-d9c5a7ba32e6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, toilet, and glass-enclosed shower.",
        "public_id": "019fd956-16ea-73b0-8648-d9c5a7ba32e6",
        "storage_key": "property/6767906449166312/019fd956-16ea-73b0-8648-d9c5a7ba32e6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a spacious vanity with ample counter space, a sleek toilet, and a refreshing glass-enclosed shower. Perfect for unwinding.",
      "link": "false",
      "alt_text": "Modern white bathroom with vanity, mirror, sink, and toilet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-3-1920w.jpg"
    },
    {
      "id": "custom_3bc75a8f-fbc8-446c-a2e2-6ce30c603c6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-18b3-7730-8fd0-2f1433d39ffb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, silver faucet, glass-enclosed shower, and a toilet.",
        "public_id": "019fd956-18b3-7730-8fd0-2f1433d39ffb",
        "storage_key": "property/6767906449166312/019fd956-18b3-7730-8fd0-2f1433d39ffb.webp",
        "width": 1280,
        "height": 850
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with white vanity, frosted glass shower, toilet, and open shelving.",
      "link": "false",
      "alt_text": "Bathroom interior in a modern apartment with a white vanity, frosted glass shower, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/d8564be8d27edf4cc9d1163d47912795-1920w.webp"
    },
    {
      "id": "custom_3fb429a7-2cbf-4965-9129-9a32db8e6be0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-210d-75b7-9678-e07f5ce0951e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern building.",
        "public_id": "019fd956-210d-75b7-9678-e07f5ce0951e",
        "storage_key": "property/6767906449166312/019fd956-210d-75b7-9678-e07f5ce0951e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor pool with turquoise water, lounge chairs, and a white resort building under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-19-358e5b45-1920w.jpg"
    },
    {
      "id": "custom_3e14c930-e44f-49d8-8735-7aa56dab5a35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-218d-72f4-bd96-65833502ba3c.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with lounge chairs and a tall apartment building in the background.",
        "public_id": "019fd956-218d-72f4-bd96-65833502ba3c",
        "storage_key": "property/6767906449166312/019fd956-218d-72f4-bd96-65833502ba3c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Outdoor pool with turquoise water, lounge chairs, and a tall white building under a clear blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-20-e6d6b69a-1920w.jpg"
    },
    {
      "id": "custom_7f79b429-e0e6-40b1-b58d-f53f46d3253b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2191-774a-818f-b52a452b2812.webp",
      "image_media": {
        "alt_text": "Outdoor tennis and pickleball courts with nets and bright blue surfaces.",
        "public_id": "019fd956-2191-774a-818f-b52a452b2812",
        "storage_key": "property/6767906449166312/019fd956-2191-774a-818f-b52a452b2812.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Outdoor pickleball courts with turquoise surface, net, and nearby apartment buildings under a blue sky",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-15-1920w.jpg"
    },
    {
      "id": "custom_300b7609-7faa-42ff-a980-3ea39193ebe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2362-7399-9865-ff0a116fe69d.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a tunnel, ramp, and stepping stones.",
        "public_id": "019fd956-2362-7399-9865-ff0a116fe69d",
        "storage_key": "property/6767906449166312/019fd956-2362-7399-9865-ff0a116fe69d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Let your furry friends play and exercise in our dedicated dog park, complete with fun agility equipment.",
      "link": "false",
      "alt_text": "Fenced dog park",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-16-1920w.jpg"
    },
    {
      "id": "custom_c8109fba-c5e0-4115-a7a0-38f68e79f7f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2c29-70ad-b6bf-667b441286ff.webp",
      "image_media": {
        "alt_text": "Modern outdoor seating area with a fire pit and view of the pool.",
        "public_id": "019fd956-2c29-70ad-b6bf-667b441286ff",
        "storage_key": "property/6767906449166312/019fd956-2c29-70ad-b6bf-667b441286ff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating and a cozy fire pit, perfect for relaxing evenings by the pool.",
      "link": "false",
      "alt_text": "Outdoor patio with blue seating, fire pit",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-17-1920w.jpg"
    },
    {
      "id": "custom_1b6f0bd0-cdc3-4673-bd26-97f3f9e79dd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2cf4-7583-963b-284c0eec8fff.webp",
      "image_media": {
        "alt_text": "Playground with blue slides and climbing structure.",
        "public_id": "019fd956-2cf4-7583-963b-284c0eec8fff",
        "storage_key": "property/6767906449166312/019fd956-2cf4-7583-963b-284c0eec8fff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a fun and safe playground for children.",
      "link": "false",
      "alt_text": "Blue playground slide structure on a woodchip playground surrounded by green trees and grass.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-14-1920w.jpg"
    },
    {
      "id": "custom_fe176195-2e53-4126-8999-aa69ab43b94f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2eb0-700c-a50f-ebe89c2941d7.webp",
      "image_media": {
        "alt_text": "Outdoor patio with a fire pit, lounge seating, and a grilling area under a pergola.",
        "public_id": "019fd956-2eb0-700c-a50f-ebe89c2941d7",
        "storage_key": "property/6767906449166312/019fd956-2eb0-700c-a50f-ebe89c2941d7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Outdoor patio with blue sofas, white chairs, a fire pit, and a pergola beside a white building",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-18-1920w.jpg"
    },
    {
      "id": "custom_02b3de7c-f229-437c-9308-69ec6e559737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-2f97-72fe-857a-ea05590a81ff.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with built-in grill and seating area under a wooden pergola.",
        "public_id": "019fd956-2f97-72fe-857a-ea05590a81ff",
        "storage_key": "property/6767906449166312/019fd956-2f97-72fe-857a-ea05590a81ff.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Outdoor community patio under a wooden pergola with a built-in grill and white dining tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/a1a6c46afcfba2dc3e6e929dae177a10-1920w.jpg"
    },
    {
      "id": "custom_450a103b-4021-48cd-84cf-9c799fd784b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-373e-7120-9b0a-d39e02e4049b.webp",
      "image_media": {
        "alt_text": "Game room with pool table, couch, and TV.",
        "public_id": "019fd956-373e-7120-9b0a-d39e02e4049b",
        "storage_key": "property/6767906449166312/019fd956-373e-7120-9b0a-d39e02e4049b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the community game room, featuring a billiards table, comfortable seating, and entertainment options.",
      "link": "false",
      "alt_text": "Recreation room with a pool table, TV, couches",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-10-1920w.jpg"
    },
    {
      "id": "custom_4d75e0a4-e66b-485b-b6d2-0636d8960f5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3775-77fa-b2d0-e8a3ad23cd4e.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, exercise bikes, and weight machines",
        "public_id": "019fd956-3775-77fa-b2d0-e8a3ad23cd4e",
        "storage_key": "property/6767906449166312/019fd956-3775-77fa-b2d0-e8a3ad23cd4e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines and strength training equipment for residents.",
      "link": "false",
      "alt_text": "Modern gym room with treadmills, exercise bikes, and weight equipment under bright overhead lights",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-9-1920w.jpg"
    },
    {
      "id": "custom_7f8599ef-d248-4cb1-9f47-9a18b6bf0865",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3a28-725b-81b0-607d3ff94544.webp",
      "image_media": {
        "alt_text": "Gym with dumbbell rack, weight bench, and exercise equipment visible through doorway.",
        "public_id": "019fd956-3a28-725b-81b0-607d3ff94544",
        "storage_key": "property/6767906449166312/019fd956-3a28-725b-81b0-607d3ff94544.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of weights, cardio equipment, and machines for a complete workout.",
      "link": "false",
      "alt_text": "Empty modern gym with bench, dumbbells, mirrors, and gray flooring in a bright indoor space",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-8-1920w.jpg"
    },
    {
      "id": "custom_c3a30711-eebc-43e9-8625-c838651f4961",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3db6-72cd-b3b4-5bcf5df82a46.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with deep blue sectional sofa, modern armchairs, and a coffee table.",
        "public_id": "019fd956-3db6-72cd-b3b4-5bcf5df82a46",
        "storage_key": "property/6767906449166312/019fd956-3db6-72cd-b3b4-5bcf5df82a46.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Spacious modern resident lounge with blue walls, circular pendant lights, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/6a697567891928432712f41fedb41b84-1920w.webp"
    },
    {
      "id": "custom_bfbb21b1-999a-4837-8616-bfe11e701512",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-420a-70ca-a715-faf2d9c624dd.webp",
      "image_media": {
        "alt_text": "Modern lounge area with stylish seating, a coffee table, and large windows overlooking an outdoor patio.",
        "public_id": "019fd956-420a-70ca-a715-faf2d9c624dd",
        "storage_key": "property/6767906449166312/019fd956-420a-70ca-a715-faf2d9c624dd.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Interior community lounge with contemporary seating, a coffee table, and large glass doors opening to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/10b6b99bc5219e9821b00ea99006c45a-1920w.jpg"
    },
    {
      "id": "custom_766784be-9f58-4815-aa9f-f88ed902c6ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-430f-7156-a2f2-43fec0906b8f.webp",
      "image_media": {
        "alt_text": "Indoor parking garage with cars parked and directional signs.",
        "public_id": "019fd956-430f-7156-a2f2-43fec0906b8f",
        "storage_key": "property/6767906449166312/019fd956-430f-7156-a2f2-43fec0906b8f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Underground parking garage at a multifamily property featuring concrete pillars, overhead lighting, and clearly marked traffic lanes.",
      "link": "false",
      "alt_text": "Underground parking garage with concrete pillars and parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/5767906449162442/6767906449166312/1eb60377d2ae6ffa9b1df1ed0b573fd5-1920w.jpg"
    },
    {
      "id": "custom_2b53ce7a-57d6-41ee-83f4-c8086ad09108",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-4548-712b-8da0-708e83b860db.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with a large parking lot.",
        "public_id": "019fd956-4548-712b-8da0-708e83b860db",
        "storage_key": "property/6767906449166312/019fd956-4548-712b-8da0-708e83b860db.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A wide shot of a modern apartment building with a large parking lot and lush green trees.",
      "link": "false",
      "alt_text": "Large white and gray building with parking lot and cars on a sunny day",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-12-1920w.jpg"
    },
    {
      "id": "custom_f0594155-16d0-4474-962a-bfed64354f24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-498f-74cc-9fe8-f5c4f70075ff.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern, tall apartment building with white and gray facade and blue-tinted windows, surrounded by green trees.",
        "public_id": "019fd956-498f-74cc-9fe8-f5c4f70075ff",
        "storage_key": "property/6767906449166312/019fd956-498f-74cc-9fe8-f5c4f70075ff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring a striking modern exterior design with white and gray accents and numerous blue-tinted windows.",
      "link": "false",
      "alt_text": "Large white and gray building with parking lot and cars on a sunny day",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-13-1920w.jpg"
    },
    {
      "id": "custom_bb859e8b-3969-4cfd-af48-eeb10f1f6784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-4dc5-76c5-9140-272e298cdb1c.webp",
      "image_media": {
        "alt_text": "Cherry Hill Towers exterior signage and building",
        "public_id": "019fd956-4dc5-76c5-9140-272e298cdb1c",
        "storage_key": "property/6767906449166312/019fd956-4dc5-76c5-9140-272e298cdb1c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Cherry Hill Towers exterior signage and building",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/8b8e5aa1/dms3rep/multi/opt/Cherry+Hill+Towers+POI-11-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a2a1ef0f-0d66-4aac-a380-a7664f53c308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Chick's Deli",
      "poi_type": "Restaurants",
      "poi_address": "906 Township Ln, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Buffalo chicken cheesesteaks star in this longtime, no-frills fixture for hoagies & platters.",
      "poi_long_description": "Buffalo chicken cheesesteaks star in this longtime, no-frills fixture for hoagies & platters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a18d-701c-8826-611987d86c35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a18d-701c-8826-611987d86c35",
        "storage_key": "property/6767906449166312/019d0265-a18d-701c-8826-611987d86c35.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "http://chicksdeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2785984412378964715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicks-deli",
      "poi_latitude": "39.9165033",
      "poi_longitude": "-75.02127229999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-429-2022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu5a3SJnLxokR66Kf8Q_OqSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_e9d5d18c-99c2-4ebc-aeaf-3b54b55f8717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Maggiano's Little Italy",
      "poi_type": "Restaurants",
      "poi_address": "2000 NJ-38 Suite 1180, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_long_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-9fe9-738e-8ca3-445067b0ce53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9fe9-738e-8ca3-445067b0ce53",
        "storage_key": "property/6767906449166312/019d0265-9fe9-738e-8ca3-445067b0ce53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.maggianos.com/locations/new-jersey/cherry-hill/2000-route-38?utm_source=google&utm_medium=organic&utm_campaign=Maggianos",
      "poi_directions_map_url": "https://maps.google.com/?cid=7422919111606451790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggianos-little-italy",
      "poi_latitude": "39.9401068",
      "poi_longitude": "-75.0244147",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-792-4470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSGlTK3LxokRTr7Ci5qBA2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_fb647c8c-fae2-4ad7-9ae2-1343a2c10ac4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Kooma Cherry Hill.",
      "poi_type": "Restaurants",
      "poi_address": "2000 NJ-38 #1025, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Asian eatery featuring sushi and a wide variety of cooked options in a contemporary interior.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-9ffa-74d1-b6ba-2c238651583f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-9ffa-74d1-b6ba-2c238651583f",
        "storage_key": "property/6767906449166312/019d0265-9ffa-74d1-b6ba-2c238651583f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://koomacherryhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990128169581849815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kooma-cherry-hill",
      "poi_latitude": "39.940346",
      "poi_longitude": "-75.02354",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-486-5140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfRcT4PLxokR16xsrQZbnhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_805702f7-f325-4f39-801e-948b2bcb24c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Eddie V's Prime Seafood",
      "poi_type": "Restaurants",
      "poi_address": "2000 NJ-38 #1072, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Elegant fine-dining chain with a seafood & steak menu, plus a cocktail lounge featuring live jazz",
      "poi_long_description": "Elegant fine-dining chain with a seafood & steak menu, plus a cocktail lounge featuring live jazz",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a021-7430-b3e8-7996ebfbfca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a021-7430-b3e8-7996ebfbfca2",
        "storage_key": "property/6767906449166312/019d0265-a021-7430-b3e8-7996ebfbfca2.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.eddiev.com/locations/nj/cherry-hill/cherry-hill/8533?cmpid=br:ev_ag:ie_ch:loc_ca:EVGMB_sn:gmb_gt:cherry-hill-nj-8533_pl:locurl_rd:1030",
      "poi_directions_map_url": "https://maps.google.com/?cid=6252527983757959133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddie-vs-prime-seafood",
      "poi_latitude": "39.9401255",
      "poi_longitude": "-75.0250717",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-532-9562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_QXcNfLxokR3R8V7BJxxVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_7f991aca-1bce-4cff-871f-474690cda416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Seasons 52",
      "poi_type": "Restaurants",
      "poi_address": "2000 NJ-38 Suite 1145, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_long_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a9d9-745a-a93c-6017021a6096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a9d9-745a-a93c-6017021a6096",
        "storage_key": "property/6767906449166312/019d0265-a9d9-745a-a93c-6017021a6096.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "https://www.seasons52.com/locations/nj/cherry-hill/cherry-hill/4508?cmpid=br:s52_ag:ie_ch:loc_ca:S52GMB_sn:gmb_gt:cherry-hill-nj-4508_pl:locurl_rd:1007",
      "poi_directions_map_url": "https://maps.google.com/?cid=17253449476700122446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seasons-52",
      "poi_latitude": "39.940239",
      "poi_longitude": "-75.026518",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-665-1052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSGlTK3LxokRTi3c6OKQcO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c742624e-11f0-475c-89e7-47db695a81be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Silver Diner",
      "poi_type": "Restaurants",
      "poi_address": "2131 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Modeled after the classic American diner, this regional chain supplies comfort fare & jukebox tunes.",
      "poi_long_description": "Modeled after the classic American diner, this regional chain supplies comfort fare & jukebox tunes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a9d3-722d-9545-3d4ae858076e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-a9d3-722d-9545-3d4ae858076e",
        "storage_key": "property/6767906449166312/019d0265-a9d3-722d-9545-3d4ae858076e.webp",
        "width": 1000,
        "height": 639
      },
      "poi_business_url": "http://www.silverdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2547181645187557398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-diner",
      "poi_latitude": "39.938188",
      "poi_longitude": "-75.0253821",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-910-1240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_WMdq3LxokRFqjM8zVoWSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_b3bb5495-ada3-4fbd-a135-d0802621d362",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Heng Seng Noodles",
      "poi_type": "Restaurants",
      "poi_address": "1467 Brace Rd Unit C1B, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-abbf-76ba-8fa0-c2187209a8cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-abbf-76ba-8fa0-c2187209a8cc",
        "storage_key": "property/6767906449166312/019d0265-abbf-76ba-8fa0-c2187209a8cc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://hengsengnoodles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11272942801078057668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heng-seng-noodles",
      "poi_latitude": "39.8894184",
      "poi_longitude": "-75.01598849999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-522-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UEOv1LNxokRxPqNP8CJcZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f346fb37-2613-411a-9718-bb7473a25bd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Croce Pasta & Italian Specialties",
      "poi_type": "Restaurants",
      "poi_address": "811 Marlton Pike, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Family-run Italian market offering specialty groceries, plus prepared foods, and baked goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-ac9b-7635-babe-450b2264c801.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ac9b-7635-babe-450b2264c801",
        "storage_key": "property/6767906449166312/019d0265-ac9b-7635-babe-450b2264c801.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crocepasta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14852981754066281219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "croce-pasta--italian-specialties",
      "poi_latitude": "39.9156041",
      "poi_longitude": "-75.0209714",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-795-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfRJ-S2nLxokRA6N6-jVkIM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_663ffadc-ccf1-4da1-a3fd-abafae863b47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Sunrise Social NJ",
      "poi_type": "Restaurants",
      "poi_address": "1200 Haddonfield Rd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Trendy restaurant in the Golden Triangle specializing in brunch with creative twists on breakfast and lunch favorites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-b182-70f9-b681-2d53071724b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b182-70f9-b681-2d53071724b3",
        "storage_key": "property/6767906449166312/019d0265-b182-70f9-b681-2d53071724b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ownasunrise.com/sunrisesocialnj?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3363068289487172862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunrise-social-nj",
      "poi_latitude": "39.92036119999999",
      "poi_longitude": "-75.0332395",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-330-4857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3FA5jrLxokR_nRDfsoErC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_3f590bdb-8e5b-4a3f-bf28-33fdd7002340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "La Liégeoise",
      "poi_type": "Restaurants",
      "poi_address": "1871 Marlton Pike #8, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-b1ca-74cc-8080-988a893d69e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b1ca-74cc-8080-988a893d69e7",
        "storage_key": "property/6767906449166312/019d0265-b1ca-74cc-8080-988a893d69e7.webp",
        "width": 1280,
        "height": 1194
      },
      "poi_business_url": "https://www.laliegeoise.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4055233453557660656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-ligeoise",
      "poi_latitude": "39.90336689999999",
      "poi_longitude": "-74.9710836",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-524-7040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_j0UZvLxokR8LuVKFcVRzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_57064779-e043-41c8-b38a-da8a2a9f4d73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Trappixx Jamaican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2442 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Traditional Jamaican dishes are the draw at this compact, strip-mall eatery with a relaxed ambiance.",
      "poi_long_description": "Traditional Jamaican dishes are the draw at this compact, strip-mall eatery with a relaxed ambiance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-b5dd-775b-bef7-a93230505e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b5dd-775b-bef7-a93230505e34",
        "storage_key": "property/6767906449166312/019d0265-b5dd-775b-bef7-a93230505e34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trappixxjamaicaneat.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7607668588299295579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trappixx-jamaican-restaurant",
      "poi_latitude": "39.9415626",
      "poi_longitude": "-75.00562",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-755-5955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWoDX_zKxokRWxt6Hkbek2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_80fe4dca-7d7e-48f1-bf48-1affaa02c617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Ruby Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2100 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Chic dining room surrounds a large spread of Japanese, Chinese & seafood specialties.",
      "poi_long_description": "Chic dining room surrounds a large spread of Japanese, Chinese & seafood specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-b700-75e8-8797-629bd1ebc801.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-b700-75e8-8797-629bd1ebc801",
        "storage_key": "property/6767906449166312/019d0265-b700-75e8-8797-629bd1ebc801.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15709538875093771640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruby-buffet",
      "poi_latitude": "39.941674",
      "poi_longitude": "-75.0177844",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-321-8288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8fuXVPKxokReGUny19-A9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_32b908a5-7626-4dda-a310-ed664388c3a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Toscana",
      "poi_type": "Restaurants",
      "poi_address": "1990 Marlton Pike, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "Traditional Tuscan restaurant serving wood-fired pizzas, plus a bar for beer, wine & cocktails.",
      "poi_long_description": "Traditional Tuscan restaurant serving wood-fired pizzas, plus a bar for beer, wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-bb37-7593-89d4-eef7b91ee2b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bb37-7593-89d4-eef7b91ee2b8",
        "storage_key": "property/6767906449166312/019d0265-bb37-7593-89d4-eef7b91ee2b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.toscanacherryhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11620811569914831242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toscana",
      "poi_latitude": "39.8997512",
      "poi_longitude": "-74.9531776",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-489-7373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQkbmaU0wYkRiuGFmo1qRaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_dd40c270-332a-4f5f-9308-89c98ef548e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "The Farm and Fisherman Tavern",
      "poi_type": "Restaurants",
      "poi_address": "1442 Marlton Pike, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "Locally sourced fare served from breakfast through dinner in a modern eatery with a market.",
      "poi_long_description": "Locally sourced fare served from breakfast through dinner in a modern eatery with a market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-bee6-75e1-acb8-db4e8f17f3a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bee6-75e1-acb8-db4e8f17f3a9",
        "storage_key": "property/6767906449166312/019d0265-bee6-75e1-acb8-db4e8f17f3a9.webp",
        "width": 625,
        "height": 900
      },
      "poi_business_url": "http://fandftavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9751502458842998001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-farm-and-fisherman-tavern",
      "poi_latitude": "39.9110908",
      "poi_longitude": "-74.9915869",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-356-2282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44q5DELLxokR8WSvFdJLVIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0c08e126-d120-425c-8f25-69f870538aef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2110 NJ-38 Unit 1A, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-bf86-76af-95de-1fada373e628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bf86-76af-95de-1fada373e628",
        "storage_key": "property/6767906449166312/019d0265-bf86-76af-95de-1fada373e628.webp",
        "width": 1280,
        "height": 470
      },
      "poi_business_url": "https://stores.aldi.us/nj/cherry-hill/2110-route-38?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=5728522965547817956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.9403014",
      "poi_longitude": "-75.01867519999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-339a-7158-ad26-4e3fe4c9f99c",
        "storage_key": "property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ6Qz-bKxokR5BslQUnNf08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_6b3691af-aa7e-48c6-8bd6-5e2905e98ddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2137 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-bf8d-70e8-9013-5206df7d7608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-bf8d-70e8-9013-5206df7d7608",
        "storage_key": "property/6767906449166312/019d0265-bf8d-70e8-9013-5206df7d7608.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "https://www.target.com/sl/cherry-hill/1085",
      "poi_directions_map_url": "https://maps.google.com/?cid=10410965302907417583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.9343503",
      "poi_longitude": "-75.02515389999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-317-1445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxf1FIq7LxokR77O2iMgte5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2974639a-0835-4375-978f-d96513c0c672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-c4af-734c-8668-a7713038116f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c4af-734c-8668-a7713038116f",
        "storage_key": "property/6767906449166312/019d0265-c4af-734c-8668-a7713038116f.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8336?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=2246686306568094872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.936497",
      "poi_longitude": "-75.04849",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-661-0140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3398-733b-8383-ae4362664508",
        "storage_key": "property/6767906449166312/019d0266-3398-733b-8383-ae4362664508.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2gvq8_LxokRmMS52ErVLR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c3a34f90-a87e-4957-9b59-c9ef52266ec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "775 Haddonfield Rd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-c61e-76c3-b7a4-4779b1bbb5b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c61e-76c3-b7a4-4779b1bbb5b5",
        "storage_key": "property/6767906449166312/019d0265-c61e-76c3-b7a4-4779b1bbb5b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/nj/cherry-hill/613/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16094176871358450645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.9289518",
      "poi_longitude": "-75.03296019999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-488-0801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-339a-7158-ad26-4e3fe4c9f99c",
        "storage_key": "property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UvxmRzLxokR1cugCZgAWt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a973b1cf-f440-4df6-b018-cc19b8a63c70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Wegmans",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 NJ-70, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Chain grocery store offering produce, baked goods, and prepared foods, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-c6e4-7563-99bd-9948696601da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c6e4-7563-99bd-9948696601da",
        "storage_key": "property/6767906449166312/019d0265-c6e4-7563-99bd-9948696601da.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.wegmans.com/stores/cherry-hill-nj/?cid=GMB_Wegmans_2024:aw:ow:gb:gb:ao::",
      "poi_directions_map_url": "https://maps.google.com/?cid=9460008237277310795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wegmans",
      "poi_latitude": "39.92285200000001",
      "poi_longitude": "-75.03492399999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-488-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-339a-7158-ad26-4e3fe4c9f99c",
        "storage_key": "property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd1O07_LxokRS-8u216zSIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1b6b11ca-1e6c-476a-83fb-cc79817ebc2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "ShopRite of Garden State Pavilion",
      "poi_type": "Shopping & Retail",
      "poi_address": "2240 W Marlton Pike, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-c70b-7458-a901-047a42607605.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-c70b-7458-a901-047a42607605",
        "storage_key": "property/6767906449166312/019d0265-c70b-7458-a901-047a42607605.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=570",
      "poi_directions_map_url": "https://maps.google.com/?cid=18306340320312772245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-garden-state-pavilion",
      "poi_latitude": "39.92948060000001",
      "poi_longitude": "-75.0429055",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-910-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-339a-7158-ad26-4e3fe4c9f99c",
        "storage_key": "property/6767906449166312/019d0266-339a-7158-ad26-4e3fe4c9f99c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWxYjsLLxokRlUanuYcvDf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8fceac20-800c-4f9d-9d6d-97e5a8863305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "650 Garden Park Blvd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-cb07-74e8-8fb1-b3d20ea38f11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cb07-74e8-8fb1-b3d20ea38f11",
        "storage_key": "property/6767906449166312/019d0265-cb07-74e8-8fb1-b3d20ea38f11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/cherry-hill-NJ-1415.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3622817115988664212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "39.9273769",
      "poi_longitude": "-75.0399838",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-406-7430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz3ugtSfLxokRlJ-19PjURjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_5c227ca9-0777-4953-bd0a-ad6a56fe7717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2130 NJ-70, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-ce99-77ad-aa8d-68d1c084317a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ce99-77ad-aa8d-68d1c084317a",
        "storage_key": "property/6767906449166312/019d0265-ce99-77ad-aa8d-68d1c084317a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/nj/cherry-hill/2130-route-70-w-1098.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=4002610481129616527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "39.9232461",
      "poi_longitude": "-75.0359817",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-910-7932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf-bFBMLLxokRj3T8nQYhjDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_4fddcbab-9447-44ad-95ba-87abd9408d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "785 Haddonfield Rd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-cf21-7396-8d83-d18cdf1cc13b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cf21-7396-8d83-d18cdf1cc13b",
        "storage_key": "property/6767906449166312/019d0265-cf21-7396-8d83-d18cdf1cc13b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13955764807523308978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "39.9287902",
      "poi_longitude": "-75.0337959",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-665-7035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjV3apUHLxokRshVT0SbWrME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_368a8dd8-6ecd-4fda-bbde-9ced87b56fa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "951 Haddonfield Rd Suite A, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Retailer selling Nordstrom's apparel and shoes at discount prices, including designer brands.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-cfd4-7647-a68e-097b453f1c4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-cfd4-7647-a68e-097b453f1c4f",
        "storage_key": "property/6767906449166312/019d0265-cfd4-7647-a68e-097b453f1c4f.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/nj/cherry-hill/951-haddonfield-rd?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=642&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=5472772866548276467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "39.9243957",
      "poi_longitude": "-75.03528539999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-773-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCz_PYb7LxokR85wBF-0x80s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ee88b26f-472c-42de-aeaf-8bcf623edf27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cherry Hill West High School",
      "poi_type": "Education",
      "poi_address": "2101 Chapel Ave, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chclc.org/west",
      "poi_directions_map_url": "https://maps.google.com/?cid=2715003727464518866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-hill-west-high-school",
      "poi_latitude": "39.9290988",
      "poi_longitude": "-75.0192742",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-663-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKYLtFKbLxokR0lRiY4GhrSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_480ec3b9-e8a6-436f-ba67-d3e31273472b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Carusi Middle School",
      "poi_type": "Education",
      "poi_address": "315 Roosevelt Dr, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-d319-70b1-b930-3f3fe09e2291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d319-70b1-b930-3f3fe09e2291",
        "storage_key": "property/6767906449166312/019d0265-d319-70b1-b930-3f3fe09e2291.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.chclc.org/carusi",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377183438295414808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carusi-middle-school",
      "poi_latitude": "39.9347",
      "poi_longitude": "-74.9992523",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-667-1220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1VgnBzLxokRGDjKe_jeCP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3b8e4429-d8c5-4d6a-a68b-70f48a7d11c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Joyce Kilmer Elementary School",
      "poi_type": "Education",
      "poi_address": "2900 Chapel Ave W, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chclc.org/kilmer",
      "poi_directions_map_url": "https://maps.google.com/?cid=11961606647869948095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joyce-kilmer-elementary-school",
      "poi_latitude": "39.9272383",
      "poi_longitude": "-75.0054967",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-667-3903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcbFUjg_LxokRv0A99d4pAKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d215aa18-2e19-4b99-8167-e2f9c7f19de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Clara Barton Elementary School",
      "poi_type": "Education",
      "poi_address": "223 Rhode Island Ave, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://barton.chclc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15285454861446098286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clara-barton-elementary-school",
      "poi_latitude": "39.9229259",
      "poi_longitude": "-75.0136998",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-667-3303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1wJ7bgrLxokRbi3D7jXYINQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_19c43866-abd0-4790-a58d-626ca45f95a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Rosa International Middle School",
      "poi_type": "Education",
      "poi_address": "485 Browning Ln, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-d57a-739f-a71b-983d966b619a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d57a-739f-a71b-983d966b619a",
        "storage_key": "property/6767906449166312/019d0265-d57a-739f-a71b-983d966b619a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://rosa.chclc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17752521756567585722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosa-international-middle-school",
      "poi_latitude": "39.8869743",
      "poi_longitude": "-74.9962005",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-616-8787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYdrZq5DMxokRusOaD3ugXfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_941c6090-fade-4481-9fe3-8e87fc5a0f0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Estelle V. Malberg Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "1220 Winston Way, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chclc.org/Domain/8",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788040951586779639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "estelle-v-malberg-early-childhood-center",
      "poi_latitude": "39.9030189",
      "poi_longitude": "-74.9921036",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-429-7283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPXSgfWfLxokR93HeezH2WL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_553e029e-c43a-430b-94fe-6784eceadd52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "St. Andrew's Nursery School & Kindergarten",
      "poi_type": "Education",
      "poi_address": "327 Marlton Pike, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-d6e6-7420-9d88-d20c9b241f5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d6e6-7420-9d88-d20c9b241f5d",
        "storage_key": "property/6767906449166312/019d0265-d6e6-7420-9d88-d20c9b241f5d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://stanurseryschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1718222429359381238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-andrews-nursery-school--kindergarten",
      "poi_latitude": "39.9141982",
      "poi_longitude": "-75.0139458",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-429-4470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8032_XXLxokR9hoTKzJa2Bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a6b974b2-36c6-4e0f-a4f1-0b01797f9218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Politz Day School",
      "poi_type": "Education",
      "poi_address": "718 Cooper Landing Rd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.politz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9342187259683832389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "politz-day-school",
      "poi_latitude": "39.9329147",
      "poi_longitude": "-75.0130844",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-667-1013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF7jIbAfLxokRRYKiztAdpoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0368ad53-70c9-4d29-96fb-d13f4679bf3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Katz JCC",
      "poi_type": "Education",
      "poi_address": "1301 Springdale Rd, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-d77b-77da-a1d0-7bc3400c5b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-d77b-77da-a1d0-7bc3400c5b22",
        "storage_key": "property/6767906449166312/019d0265-d77b-77da-a1d0-7bc3400c5b22.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "http://www.katzjcc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14830995208780076041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katz-jcc",
      "poi_latitude": "39.8823539",
      "poi_longitude": "-74.968004",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-424-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEXp3ubLMxokRCVTbfJBH0s0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_67613046-742a-46e5-8d2a-7e649875d385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "American Institute - Cherry Hill",
      "poi_type": "Education",
      "poi_address": "2201 NJ-38 8th floor, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-daea-76bf-8611-a7142e78cb3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-daea-76bf-8611-a7142e78cb3e",
        "storage_key": "property/6767906449166312/019d0265-daea-76bf-8611-a7142e78cb3e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.americaninstitute.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7312387115705485091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-institute---cherry-hill",
      "poi_latitude": "39.9393897",
      "poi_longitude": "-75.01543219999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 856-444-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAWt3PjDLxokRI8fEy1bRemU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_08dfa443-6e44-4e59-ab45-61057a8881a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "AMC Cherry Hill 24",
      "poi_type": "Entertainment",
      "poi_address": "2121 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Cinema hosting first-run films, plus arcade games and a snacks bar concession area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-dd8f-7052-b566-79da02428382.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-dd8f-7052-b566-79da02428382",
        "storage_key": "property/6767906449166312/019d0265-dd8f-7052-b566-79da02428382.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-cherry-hill-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10397822825364311536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-cherry-hill-24",
      "poi_latitude": "39.9362666",
      "poi_longitude": "-75.0280988",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-486-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-389e-74aa-bcb0-8320a83f834a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-389e-74aa-bcb0-8320a83f834a",
        "storage_key": "property/6767906449166312/019d0266-389e-74aa-bcb0-8320a83f834a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4dPg7HLxokR8M1JB8V8TJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_024956c4-997e-410c-a224-3070bdb0e693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Barclay Farmstead Museum",
      "poi_type": "Entertainment",
      "poi_address": "209 Barclay Ln, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "This Quaker farmhouse, gardens & trails offer guests a view of living history from the early 1800s.",
      "poi_long_description": "This Quaker farmhouse, gardens & trails offer guests a view of living history from the early 1800s.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-de5c-70eb-a107-ad6ccd3e2289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-de5c-70eb-a107-ad6ccd3e2289",
        "storage_key": "property/6767906449166312/019d0265-de5c-70eb-a107-ad6ccd3e2289.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chnj.gov/847/Barclay-Farmstead",
      "poi_directions_map_url": "https://maps.google.com/?cid=1236071765722206418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barclay-farmstead-museum",
      "poi_latitude": "39.9051152",
      "poi_longitude": "-74.9981763",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-795-6225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3896-777a-ba5e-dd6af55393a2",
        "storage_key": "property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27KbD6_LxokR0hDD0LhoJxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_41c4389e-d04a-4cbd-b8eb-d12feb44a86a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Springdale Farm Market",
      "poi_type": "Entertainment",
      "poi_address": "1638 Springdale Rd, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "Sprawling working farm with a produce market, bakery & plant nursery, plus a seasonal corn maze.",
      "poi_long_description": "Sprawling working farm with a produce market, bakery & plant nursery, plus a seasonal corn maze.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-e089-70ab-b712-4b06ed5220f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e089-70ab-b712-4b06ed5220f2",
        "storage_key": "property/6767906449166312/019d0265-e089-70ab-b712-4b06ed5220f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.springdalefarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13510266257537948321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springdale-farm-market",
      "poi_latitude": "39.8911308",
      "poi_longitude": "-74.9686866",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-424-8674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxyxZJ6vMxokRodp-rZQbfrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_253f2464-8411-4d5e-b998-898eaea0e4ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Bury the Hatchet",
      "poi_type": "Entertainment",
      "poi_address": "1931 Olney Ave, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "Visitors to this warehouse-style space can take one-on-one ax-throwing safety lessons and compete.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-e275-70c5-b475-2eef2dc3e8f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e275-70c5-b475-2eef2dc3e8f1",
        "storage_key": "property/6767906449166312/019d0265-e275-70c5-b475-2eef2dc3e8f1.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://burythehatchet.com/axe-throwing-cherry-hill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=535808795048203265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bury-the-hatchet",
      "poi_latitude": "39.908389",
      "poi_longitude": "-74.96843199999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-272-7475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzVcpUzLxokRAdRgoEKTbwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "adventure_sports_center"
    },
    {
      "id": "custom_86615be3-dca0-4dcc-942c-e8c63f0a3782",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Freedom Mortgage Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "1 Harbour Blvd, Camden, NJ 08103, USA",
      "poi_short_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_long_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-e60c-75df-9bb4-dd2ceeacdd23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e60c-75df-9bb4-dd2ceeacdd23",
        "storage_key": "property/6767906449166312/019d0265-e60c-75df-9bb4-dd2ceeacdd23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freedommortgagepavilion.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5807470010840392946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-mortgage-pavilion",
      "poi_latitude": "39.9404754",
      "poi_longitude": "-75.13001249999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-365-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6o4sfPIxokR8iTgnzRHmFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_0707ccd4-ba69-41af-b8d2-33854e9f2e92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Adventure Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_long_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-e5dc-73c2-9cc4-441b7fa2954d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-e5dc-73c2-9cc4-441b7fa2954d",
        "storage_key": "property/6767906449166312/019d0265-e5dc-73c2-9cc4-441b7fa2954d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventureaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298813021411118508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-aquarium",
      "poi_latitude": "39.9460868",
      "poi_longitude": "-75.1311712",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 844-474-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBU1gv_LIxokRrI1AakMG5x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_572baef7-9218-47a7-90d1-6b48fd1d6664",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "BB-62 Battleship New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "100 Clinton St, Camden, NJ 08103, USA",
      "poi_short_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_long_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-eb15-7123-bbb3-38032f662047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-eb15-7123-bbb3-38032f662047",
        "storage_key": "property/6767906449166312/019d0265-eb15-7123-bbb3-38032f662047.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.battleshipnewjersey.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11001799642450627255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-62-battleship-new-jersey",
      "poi_latitude": "39.9394484",
      "poi_longitude": "-75.1330734",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-966-1652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3896-777a-ba5e-dd6af55393a2",
        "storage_key": "property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxvwROrIxokRtwpKGnw-rpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4fa3eebc-4186-42b3-9529-9c1d04e6e8a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Camden Children's Garden",
      "poi_type": "Entertainment",
      "poi_address": "3 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_long_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-ecb0-76b7-a6f7-3bd9489923ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ecb0-76b7-a6f7-3bd9489923ba",
        "storage_key": "property/6767906449166312/019d0265-ecb0-76b7-a6f7-3bd9489923ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2467232925781527763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-childrens-garden",
      "poi_latitude": "39.9441667",
      "poi_longitude": "-75.1305556",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 856-365-8733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJebu8Oe3IxokR0wxbJ0ZfPSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_adcd3b1c-3174-4276-81f6-3c5fd0ab120b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Walter K Gordon Theater",
      "poi_type": "Entertainment",
      "poi_address": "314 Linden St, Camden, NJ 08102, USA",
      "poi_short_description": "Theater, amphitheater and venue featuring musical performances, a dance academy and student-directed productions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-ed12-7572-b4b3-3f9037f1a310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-ed12-7572-b4b3-3f9037f1a310",
        "storage_key": "property/6767906449166312/019d0265-ed12-7572-b4b3-3f9037f1a310.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://vmpa.camden.rutgers.edu/theater-program/the-walter-k-gordon-theater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=374036427605345393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walter-k-gordon-theater",
      "poi_latitude": "39.948865",
      "poi_longitude": "-75.1219005",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-225-6306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfX2IGPHIxokRcQR5MCbYMAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_017024e3-7d7b-4781-bd7b-0bd3c1a57fce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Camden Shipyard & Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "1912 Broadway, Camden, NJ 08104, USA",
      "poi_short_description": "Quaint historical museum, with artifacts & photos of the shipbuilding era, in a converted church.",
      "poi_long_description": "Quaint historical museum, with artifacts & photos of the shipbuilding era, in a converted church.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-f0fe-7779-932d-82de3bf07794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f0fe-7779-932d-82de3bf07794",
        "storage_key": "property/6767906449166312/019d0265-f0fe-7779-932d-82de3bf07794.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.camdenshipyardmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6675741229472777945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-shipyard--maritime-museum",
      "poi_latitude": "39.9205231",
      "poi_longitude": "-75.1193739",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-541-7447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3896-777a-ba5e-dd6af55393a2",
        "storage_key": "property/6767906449166312/019d0266-3896-777a-ba5e-dd6af55393a2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ33uY1dHIxokR2YYnU0f_pFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dd7b9b6c-35bc-45ec-adf8-b7d45623d7e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Jefferson Cherry Hill Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2201 Chapel Ave W, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-f42f-701c-96aa-703f1a0a8790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f42f-701c-96aa-703f1a0a8790",
        "storage_key": "property/6767906449166312/019d0265-f42f-701c-96aa-703f1a0a8790.webp",
        "width": 1280,
        "height": 798
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/cherry-hill-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1210924820782060678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-cherry-hill-hospital",
      "poi_latitude": "39.9287357",
      "poi_longitude": "-75.0165973",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-488-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d1e-77b1-9c14-4583ec97a04b",
        "storage_key": "property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yIhmKfLxokRhhRrcLURzhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2d097223-9847-4780-b6b2-5571f60bd34b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cooper Urgent Care Cherry Hill",
      "poi_type": "Health and Wellness",
      "poi_address": "2001 NJ-70, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-f42e-72e9-bdde-fa7d4e3173d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f42e-72e9-bdde-fa7d4e3173d4",
        "storage_key": "property/6767906449166312/019d0265-f42e-72e9-bdde-fa7d4e3173d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cooperhealth.org/services/urgent-care-center?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_content=Urgent%20Care",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456014845917676097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-urgent-care-cherry-hill",
      "poi_latitude": "39.8974835",
      "poi_longitude": "-74.9524182",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-396-6257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfYfHNqQ0wYkRQUK--WaDOoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8589e1a7-d716-4862-89de-ecb45f7996a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Virtua Voorhees Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Bowman Dr, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-f5c0-76d8-b1df-7c6308ea6e68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f5c0-76d8-b1df-7c6308ea6e68",
        "storage_key": "property/6767906449166312/019d0265-f5c0-76d8-b1df-7c6308ea6e68.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "https://www.virtua.org/locations/voorhees-hospital?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922560869268213923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-voorhees-hospital",
      "poi_latitude": "39.84165369999999",
      "poi_longitude": "-74.9270074",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 856-247-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d1e-77b1-9c14-4583ec97a04b",
        "storage_key": "property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW1Q0S8zwYkRo1B8gFjfNsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2ec7e5ad-5c0a-43a7-b331-b49979b38b44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2137 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-f8ad-7078-8126-ae4d2afc4406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-f8ad-7078-8126-ae4d2afc4406",
        "storage_key": "property/6767906449166312/019d0265-f8ad-7078-8126-ae4d2afc4406.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/cherry-hill-nj-pharmacies/2137-route-38-cherry-hill-nj-08002/storeid=16464?WT.mc_id=LS_GOOGLE_RX_16464",
      "poi_directions_map_url": "https://maps.google.com/?cid=15227975368528573491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.9347362",
      "poi_longitude": "-75.0252376",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-317-1442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d1e-77b1-9c14-4ad187425d1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d1e-77b1-9c14-4ad187425d1b",
        "storage_key": "property/6767906449166312/019d0266-3d1e-77b1-9c14-4ad187425d1b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxf1FIq7LxokRMzSLmeqiVNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3e84a953-4d69-470b-becc-ae7650eee418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1819 NJ-70, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-fe26-769f-a6c2-f658567ff6b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fe26-769f-a6c2-f658567ff6b5",
        "storage_key": "property/6767906449166312/019d0265-fe26-769f-a6c2-f658567ff6b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1819+route+70+w-cherry+hill-nj-08002/id=6929",
      "poi_directions_map_url": "https://maps.google.com/?cid=8589472524156761314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.9184469",
      "poi_longitude": "-75.03353349999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-662-3685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0cJn5bLxokR4nRXcsDvM3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_81d208d4-e0df-4586-aba6-6a5c0aeec79c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "500 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-fd19-73ec-8b0a-bf93b4033681.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-fd19-73ec-8b0a-bf93b4033681",
        "storage_key": "property/6767906449166312/019d0265-fd19-73ec-8b0a-bf93b4033681.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/cherry-hill-kaighns-ave-nj?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12372450871086331930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.9381742",
      "poi_longitude": "-75.0470599",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-356-2656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWO_EDHLxokRGrgS5IPGs6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_704d5918-a254-452a-82ce-276cc8e3abec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Esporta Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2100 NJ-38, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-feb8-73d0-aba7-d87b6cd1074f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0265-feb8-73d0-aba7-d87b6cd1074f",
        "storage_key": "property/6767906449166312/019d0265-feb8-73d0-aba7-d87b6cd1074f.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.esportafitness.com/Pages/clubhome.aspx?clubid=148&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13454506167784721746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "esporta-fitness",
      "poi_latitude": "39.9413667",
      "poi_longitude": "-75.0209419",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-482-8565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWkvhVTKxokRUk0cFxMCuLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d27b7efd-a413-495f-8028-1bf4b6b97df6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "929 Haddonfield Rd Suite A, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-024a-7565-9775-4b9e7d6069b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-024a-7565-9775-4b9e7d6069b0",
        "storage_key": "property/6767906449166312/019d0266-024a-7565-9775-4b9e7d6069b0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/cherry-hill-new-jersey-0667?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=14993583118917829182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.9252604",
      "poi_longitude": "-75.0344025",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-282-1122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8aNkb7LxokRPgJkQWjoE9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b2c5a1dd-3c0e-4f65-acd6-392a42ee9f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "barre3",
      "poi_type": "Health and Wellness",
      "poi_address": "921 Haddonfield Rd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-03ce-72b8-81a7-c5861ee8d784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-03ce-72b8-81a7-c5861ee8d784",
        "storage_key": "property/6767906449166312/019d0266-03ce-72b8-81a7-c5861ee8d784.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://online.barre3.com/studio-locations/cherry-hill",
      "poi_directions_map_url": "https://maps.google.com/?cid=11103251864705775953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barre3",
      "poi_latitude": "39.925576",
      "poi_longitude": "-75.0351489",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-324-0213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0_YXEzLxokRUTl7T76sFpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cddadb66-a75f-4a89-910f-d0e4de3dde24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cooper River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "510 Park Blvd, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Park with a playground, track, picnic areas, and trails, plus a boathouse and opportunities for rowing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-0704-7160-b062-9a94106a4372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0704-7160-b062-9a94106a4372",
        "storage_key": "property/6767906449166312/019d0266-0704-7160-b062-9a94106a4372.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.camdencounty.com/service/parks/cooper-river-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804839993757367986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-river-park",
      "poi_latitude": "39.9253923",
      "poi_longitude": "-75.0562307",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-216-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTz2fITTLxokRsn63Fx3L7CY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4d697b7-0b6c-4a7c-bcc7-952f8bc7e39c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Croft Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Bortons Mill Rd, Cherry Hill Township, NJ 08033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-0a0b-7422-b52c-db133cf6d20d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0a0b-7422-b52c-db133cf6d20d",
        "storage_key": "property/6767906449166312/019d0266-0a0b-7422-b52c-db133cf6d20d.webp",
        "width": 1280,
        "height": 980
      },
      "poi_business_url": "http://www.chnj.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986710099795172124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "croft-farm",
      "poi_latitude": "39.8997462",
      "poi_longitude": "-75.0201562",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-488-7868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVf5T4_NxokRHNtwcSI03N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1c7383a3-7e33-417b-95b8-f2f6d20268bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Challenge Grove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 Bortons Mill Rd, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "This 18-acre park features playgrounds, a bike path, picnic areas, sports facilities & a garden.",
      "poi_long_description": "This 18-acre park features playgrounds, a bike path, picnic areas, sports facilities & a garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-09ae-7415-8bac-bea39b7be956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-09ae-7415-8bac-bea39b7be956",
        "storage_key": "property/6767906449166312/019d0266-09ae-7415-8bac-bea39b7be956.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.camdencounty.com/service/parks/challenge-grove-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14505358341915771838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "challenge-grove-park",
      "poi_latitude": "39.89986",
      "poi_longitude": "-75.0178885",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-216-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTINfX_MxokRvoOjLY9iTck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e4a130e2-115b-47a3-8c7f-084be2c8fe3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Wallworth Pond",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Blvd, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "Relaxed park featuring trails, fishing opportunities, swans and dam views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-0c85-722c-b376-0ed1b4d2b71c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0c85-722c-b376-0ed1b4d2b71c",
        "storage_key": "property/6767906449166312/019d0266-0c85-722c-b376-0ed1b4d2b71c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5772744643679272711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wallworth-pond",
      "poi_latitude": "39.9017692",
      "poi_longitude": "-75.0198595",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-795-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xlBxIDLxokRB7-KCavoHFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e53f5d5d-1d5d-42dd-a359-2e63b445488b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Lion's Den Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "New York Ave & New Hampshire Ave, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Small neighborhood park featuring swings & a playscape for children, plus grassy areas.",
      "poi_long_description": "Small neighborhood park featuring swings & a playscape for children, plus grassy areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-0ed1-73ce-8ae2-87c3ee44a879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-0ed1-73ce-8ae2-87c3ee44a879",
        "storage_key": "property/6767906449166312/019d0266-0ed1-73ce-8ae2-87c3ee44a879.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=53285399854355741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lions-den-park",
      "poi_latitude": "39.9180003",
      "poi_longitude": "-75.0138357",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt41Z4p_LxokRHZUI8slOvQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2fa24205-d38c-4dfd-8a6e-0e31ae18ce29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cherry Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Royal Anne Ln, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Neighborhood playground featuring swings, slides and a baseball field, plus woodland tracks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1197-770a-bde7-5ce13f6dbded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1197-770a-bde7-5ce13f6dbded",
        "storage_key": "property/6767906449166312/019d0266-1197-770a-bde7-5ce13f6dbded.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chnj.gov/1135/Parks-and-Facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=16519596486302874983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-valley-park",
      "poi_latitude": "39.938857",
      "poi_longitude": "-74.993943",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXSrsuHKxokRZ73fznplQeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_94aa72e9-b549-458a-a99b-9b3ab6557694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Erlton School Park and Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "999 Jefferson Ave, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Public park featuring tennis and basketball courts, baseball and soccer fields, and a playground with swings and slides.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1200-767f-878a-5ed14b6ceffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1200-767f-878a-5ed14b6ceffb",
        "storage_key": "property/6767906449166312/019d0266-1200-767f-878a-5ed14b6ceffb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17762499967876173065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "erlton-school-park-and-playground",
      "poi_latitude": "39.91193500000001",
      "poi_longitude": "-75.02504909999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-488-7868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-38f7-720c-a234-627040cc7089",
        "storage_key": "property/6767906449166312/019d0266-38f7-720c-a234-627040cc7089.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTtfvZrLxokRCY0lbJwTgfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_38507597-1df8-48d7-b3a7-ed11c0874c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Decou Lacrosse and Soccer Field Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Cropwell Rd, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "Turf and grass fields for basketball, tennis, soccer and rugby teams.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-149c-7660-8f93-cf0066d5649e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-149c-7660-8f93-cf0066d5649e",
        "storage_key": "property/6767906449166312/019d0266-149c-7660-8f93-cf0066d5649e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204906261899787619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "decou-lacrosse-and-soccer-field-complex",
      "poi_latitude": "39.8667907",
      "poi_longitude": "-74.9594858",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0aVSTczwYkRYz16sZSJYKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_0fc44a83-343a-4f2f-9575-38974001474a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Woodcrest",
      "poi_type": "Transportation & Transit",
      "poi_address": "Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-16ea-72d5-9a7d-cebe7d6e8b34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-16ea-72d5-9a7d-cebe7d6e8b34",
        "storage_key": "property/6767906449166312/019d0266-16ea-72d5-9a7d-cebe7d6e8b34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridepatco.org/stations/woodcrest.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242536375377376350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodcrest",
      "poi_latitude": "39.8700839",
      "poi_longitude": "-75.0115141",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_osC_fMxokRXrTeCkBgPhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_e43b70fa-546a-4c69-8e22-bfa82de88722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cherry Hill",
      "poi_type": "Transportation & Transit",
      "poi_address": "3 Union Ave, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1927-7296-ae83-c3aef865c2cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1927-7296-ae83-c3aef865c2cd",
        "storage_key": "property/6767906449166312/019d0266-1927-7296-ae83-c3aef865c2cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=28",
      "poi_directions_map_url": "https://maps.google.com/?cid=449865964669119165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-hill",
      "poi_latitude": "39.9284716",
      "poi_longitude": "-75.0417774",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d21-710a-8580-1e41dbcd88ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d21-710a-8580-1e41dbcd88ec",
        "storage_key": "property/6767906449166312/019d0266-3d21-710a-8580-1e41dbcd88ec.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfo-zMbLxokRvSqkHLY-PgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a87f32a1-d686-4cbc-81f3-917521a065de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Lindenwold",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Berlin Rd N, Lindenwold, NJ 08021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1965-72dd-954f-c1a8d1cef856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1965-72dd-954f-c1a8d1cef856",
        "storage_key": "property/6767906449166312/019d0266-1965-72dd-954f-c1a8d1cef856.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridepatco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081146720755170580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindenwold",
      "poi_latitude": "39.8339631",
      "poi_longitude": "-75.0006423",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d21-710a-8580-1e41dbcd88ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d21-710a-8580-1e41dbcd88ec",
        "storage_key": "property/6767906449166312/019d0266-3d21-710a-8580-1e41dbcd88ec.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR8XzW3NxokRFL2Mr721K98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_22bd1833-1af0-43d9-a536-037c57bd26de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Walter Rand Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Camden, NJ 08103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1a5c-7464-b580-6082dfda53f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1a5c-7464-b580-6082dfda53f3",
        "storage_key": "property/6767906449166312/019d0266-1a5c-7464-b580-6082dfda53f3.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=38307",
      "poi_directions_map_url": "https://maps.google.com/?cid=6124511133795613462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walter-rand-transportation-center",
      "poi_latitude": "39.943337",
      "poi_longitude": "-75.11853099999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d48-757a-b184-43255665ee74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d48-757a-b184-43255665ee74",
        "storage_key": "property/6767906449166312/019d0266-3d48-757a-b184-43255665ee74.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSNZs_rIxokRFvvPWG2i_lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_55cc84a8-c2cf-418e-b0a3-fe00e83fbb80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Pennsauken Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "315 Derousse Ave, Pennsauken, NJ 08110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1e82-7279-8ae9-d39e211a76b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1e82-7279-8ae9-d39e211a76b4",
        "storage_key": "property/6767906449166312/019d0266-1e82-7279-8ae9-d39e211a76b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.njtransit.com/station/pennsauken-transit-center-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=15596799152665299048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsauken-transit-center",
      "poi_latitude": "39.9778914",
      "poi_longitude": "-75.0608582",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 973-275-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-423a-720f-82af-99bc54e9ce53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-423a-720f-82af-99bc54e9ce53",
        "storage_key": "property/6767906449166312/019d0266-423a-720f-82af-99bc54e9ce53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWo-gwLKxokRaIi6pzH2ctg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_50408285-2810-46fd-a127-9ab926a3cbab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Route 73/Pennsauken",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pennsauken, NJ 08110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-1fbb-7509-bc9a-906fdd6ae5f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-1fbb-7509-bc9a-906fdd6ae5f8",
        "storage_key": "property/6767906449166312/019d0266-1fbb-7509-bc9a-906fdd6ae5f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14112748441376397219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "route-73pennsauken",
      "poi_latitude": "39.993109",
      "poi_longitude": "-75.03961",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4DanfK1xokRoxewVO-N2sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_8d182f9c-97a7-44c3-9efd-2b32bde87003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cherry Hill Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 NJ-38 Ste 514, Cherry Hill Township, NJ 08002, USA",
      "poi_short_description": "Large, upscale shopping mall with an array of favorite apparel, shoe & home stores, plus eateries.",
      "poi_long_description": "Large, upscale shopping mall with an array of favorite apparel, shoe & home stores, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-205a-72cb-9281-bbb428167348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-205a-72cb-9281-bbb428167348",
        "storage_key": "property/6767906449166312/019d0266-205a-72cb-9281-bbb428167348.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://cherryhillmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16523534914655573414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-hill-mall",
      "poi_latitude": "39.939058",
      "poi_longitude": "-75.02637419999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-662-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-33a4-705d-8606-4580ea8217a0",
        "storage_key": "property/6767906449166312/019d0266-33a4-705d-8606-4580ea8217a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJT8sNolLKxokRplXPnXVjT-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ae191a3f-a5fb-4991-9b05-c1d801005193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "8000 Essington Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "8000 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3940177627801768097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8000-essington-ave",
      "poi_latitude": "39.8709941",
      "poi_longitude": "-75.26416499999999",
      "poi_miles_from_property": "22.3",
      "poi_walking_minutes": "8 hours 14 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6RdEkLDxokRodAQMa1SrjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_1db96458-ab04-49b8-b156-5b965cc828b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "31 Woodcrest Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "31 Woodcrest Rd, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?q=31+Woodcrest+Rd,+Cherry+Hill+Township,+NJ+08003,+USA&ftid=0x89c6ccf6f3852831:0x542ca21e65f73c26&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "31-woodcrest-rd",
      "poi_latitude": "39.8725087",
      "poi_longitude": "-75.01080999999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EjQzMSBXb29kY3Jlc3QgUmQsIENoZXJyeSBIaWxsIFRvd25zaGlwLCBOSiAwODAwMywgVVNBIjASLgoUChIJMSiF8_bMxokRKytV4M1JD7IQHyoUChIJaWoZi_bMxokRz1O6ZIW6D2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d387a3fd-611c-4bf2-856f-0639988fff71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "William H. Gray III 30th Street Station SEPTA Regional Rail Ticket Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "2955 Market St, Philadelphia, PA 19104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2097-719e-9b82-8283ee0ea2ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2097-719e-9b82-8283ee0ea2ae",
        "storage_key": "property/6767906449166312/019d0266-2097-719e-9b82-8283ee0ea2ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.septa.org/stations/gray-30th-street?fullscreen=false&network=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11215844726533290445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-h-gray-iii-30th-street-station-septa-regional-rail-ticket-office",
      "poi_latitude": "39.9557501",
      "poi_longitude": "-75.1819889",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 215-580-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89MTefTHxokRzXn0zFqvpps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_baca82c9-36cd-4b3a-8c78-46184476ce91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Cooper University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Cooper Plaza, Camden, NJ 08103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2491-75ae-a231-bbe4f3a76588.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2491-75ae-a231-bbe4f3a76588",
        "storage_key": "property/6767906449166312/019d0266-2491-75ae-a231-bbe4f3a76588.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cooperhealth.org/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=680027330547190836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-university-hospital",
      "poi_latitude": "39.9416173",
      "poi_longitude": "-75.1171062",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d1e-77b1-9c14-4583ec97a04b",
        "storage_key": "property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-ECnOTIxokRNIzSEkHxbwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb1c736d-3fd7-489f-8ef5-3f4d53aea8b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "The Campbell's Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Campbell Pl, Camden, NJ 08103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-25fe-7621-a088-0dde4c130497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-25fe-7621-a088-0dde4c130497",
        "storage_key": "property/6767906449166312/019d0266-25fe-7621-a088-0dde4c130497.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.campbellsoupcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9404095504793662939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-campbells-company",
      "poi_latitude": "39.9395481",
      "poi_longitude": "-75.1083244",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-257-8443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmd3NhOLIxokR2_USXQkPgoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food"
    },
    {
      "id": "custom_fe4d3ea7-48a4-47d2-9d96-9ef225e6d4fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Subaru of America",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Subaru Dr, Camden, NJ 08103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2617-711b-870a-1b67a3e3f8c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2617-711b-870a-1b67a3e3f8c7",
        "storage_key": "property/6767906449166312/019d0266-2617-711b-870a-1b67a3e3f8c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.subaru.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949239964005152156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subaru-of-america",
      "poi_latitude": "39.942594",
      "poi_longitude": "-75.108339",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-782-2783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzfHteLIxokRnLXdYKFfUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_775e10c4-47c7-418f-a097-e9f8761fdb82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Lockheed Martin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "199 Borton Landing Rd, Moorestown, NJ 08057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-293e-70c2-aac9-7a411c668d8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-293e-70c2-aac9-7a411c668d8a",
        "storage_key": "property/6767906449166312/019d0266-293e-70c2-aac9-7a411c668d8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lockheedmartin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2415388892662595380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin",
      "poi_latitude": "39.9764024",
      "poi_longitude": "-74.9173374",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 856-722-3336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3898-71e1-9083-c0ef27a7d109",
        "storage_key": "property/6767906449166312/019d0266-3898-71e1-9083-c0ef27a7d109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfFaJX1KwYkRNP-TjWYvhSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f338b12b-7a1d-4651-bd62-61e68dda2a0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Rutgers University–Camden",
      "poi_type": "Major Employers & Offices",
      "poi_address": "303 Cooper St, Camden, NJ 08102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2aca-713e-8dd5-826445d021b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2aca-713e-8dd5-826445d021b1",
        "storage_key": "property/6767906449166312/019d0266-2aca-713e-8dd5-826445d021b1.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.camden.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922792056188264575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-universitycamden",
      "poi_latitude": "39.9484052",
      "poi_longitude": "-75.1217367",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-225-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfX2IGPHIxokRf2C75puxN8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_44e825c0-761f-4a7d-aa1b-4e157ff6ebee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Camden County College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1889 Marlton Pike, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2de7-74a5-83eb-38a7c1050f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2de7-74a5-83eb-38a7c1050f28",
        "storage_key": "property/6767906449166312/019d0266-2de7-74a5-83eb-38a7c1050f28.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://camdencc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11584825996154159813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-county-college",
      "poi_latitude": "39.9024025",
      "poi_longitude": "-74.9674472",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-874-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3395-7532-a799-2101d41627f1",
        "storage_key": "property/6767906449166312/019d0266-3395-7532-a799-2101d41627f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwwaYE3LxokRxcJ6Td2RxaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e8bab965-55d9-4f41-9cb0-81db27902083",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "Penn Medicine Cherry Hill",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1865 NJ-70, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-2cf1-734c-83e9-6db56c4d9e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0266-2cf1-734c-83e9-6db56c4d9e4a",
        "storage_key": "property/6767906449166312/019d0266-2cf1-734c-83e9-6db56c4d9e4a.webp",
        "width": 1280,
        "height": 536
      },
      "poi_business_url": "https://www.pennmedicine.org/Locations/Multispecialty-location/Penn-Medicine-Cherry-Hill?y_source=1_NDE5ODEyMi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7166296848399391673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-medicine-cherry-hill",
      "poi_latitude": "39.9036129",
      "poi_longitude": "-74.97209219999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-316-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-3d1e-77b1-9c14-4583ec97a04b",
        "storage_key": "property/6767906449166312/019d0266-3d1e-77b1-9c14-4583ec97a04b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5OjDFLLxokRudvY0wPNc2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b5a62598-0e7e-46a4-ad70-0b6a4274917b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "poi_name": "TD Bank Corporate Head Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1701 Marlton Pike Suite 200, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1815243948869065304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "td-bank-corporate-head-office",
      "poi_latitude": "39.9063859",
      "poi_longitude": "-74.97948",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-751-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-4237-76cb-96ab-cd8646a5afaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4237-76cb-96ab-cd8646a5afaf",
        "storage_key": "property/6767906449166312/019d0266-4237-76cb-96ab-cd8646a5afaf.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJvWZ67Y3LxokRWJoEAcEKMRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bank"
    }
  ],
  "office_hours": [
    {
      "id": "ec_64e5679f7dc0730f835d96ad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f608b4459f724848d3d22e46",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_65946afb843c4efa1587c048",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f94f9f0d597a9f0418f156cd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_53eb74157acbbcb07eaa4d93",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e6d30ca2ac81796d03c7dc12",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_5d1fd2f28c2bb3fb16a670e6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "rating": "5",
      "name": "Melissa Conklin",
      "text": "The renovations in my apartment are beautifully done. The amenities are AMAZING!!!! Pool, gym, and dog park are the best! Can't beat the location either. The manager, Cait is great to talk to, quick to listen, and very knowledgeable!",
      "date": "2025-08-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ae805b5f-2c29-402c-b459-df75e209283d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019ebf95-89a5-72f2-b048-e7383ef217fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ebf95-89a5-72f2-b048-e7383ef217fb",
        "storage_key": "property/6767906449166312/019ebf95-89a5-72f2-b048-e7383ef217fb.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cherry Hill Towers 360 Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6307a3cb69189c4282518ac4&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_aef39c773a9307620d5b1174",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429406",
      "name": "Admin Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_91b97106d49f800fecefac72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429407",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_36694b4d7c6b902ed9ed0839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429408",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb956fad373c7b44ddd35b2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429410",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_704346a6ea325178732b008a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429411",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_65e8f34bb59693acaa79afef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429412",
      "name": "Covered Parking Space",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_89b7e8c07d6c05901c7ac64c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429414",
      "name": "Pet Fee",
      "description": "One-time fee of $350 covers up to 2 pets.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a5fc3d42186e26a18c61b3a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429416",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_469819cbc1cfaa57e0745e0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429418",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6034617eb294f90a9496c7d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "429419",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_697fd728ca3821519c886c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "536734",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c456e101cd6dc2d71b6b5575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "536735",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_36eed11ae8b5a08739d4d2ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "543087",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e6c6723b539354ebe6f1da84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "543088",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c50a6436144afc8ed7c01c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "543090",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f4853430f58e2e780ec487d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "832508",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d76f321c251d1087ec7b735f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835199",
      "name": "Storage Space",
      "description": "false",
      "amount": 30,
      "amount_max": 50,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_aa3ebee4c7ea52a4a6422051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835200",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_15400f2490d5c0d211f5858a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835201",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 65,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_241a3c5f5bd7ffd49faff8e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835204",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 65,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bf3307f9d7423d1b4d418c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835205",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_65fd5f07a387401cb787a08a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "engrain",
      "external_id": "835206",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a31a8-2db9-702d-bf91-b3c4d235f7f9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cherry Hill Towers property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312"
    },
    {
      "lead_collector_id": "019c3043-3d75-7394-aed9-d047a0f4667c",
      "lead_source": "FACEBOOK_ADS",
      "name": "cherry-hill-towers",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312"
    },
    {
      "lead_collector_id": "019c3043-3de6-7615-bb4f-c75740a5884a",
      "lead_source": "LANDING_PAGE",
      "name": "cherry-hill-towers",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-cherry-hill-nj-747",
      "search_query": "dog friendly apartments Cherry Hill NJ",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Cherry Hill, NJ",
      "h2_subtitle": "Explore dog-friendly living at Cherry Hill Towers. Our community offers spacious pet-friendly apartments and on-site amenities in Cherry Hill, NJ.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers is the perfect home for those searching for dog-friendly apartments in Cherry Hill, NJ. Our spacious one and two-bedroom floor plans cater to the needs of pet owners, offering ample space for you and your furry friends. Located near the scenic Cherry Hill Mall, our community is designed with pets in mind, featuring nearby walking trails and a picnic area for outdoor relaxation.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Cherry Hill, NJ",
      "seo_description": "Discover pet-friendly living at Cherry Hill Towers. Spacious apartments and amenities await in Cherry Hill, NJ. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pool-cherry-hill-mall-872",
      "search_query": "apartments with swimming pool Cherry Hill Mall",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool Near Cherry Hill Mall",
      "h2_subtitle": "Dive into luxury at Cherry Hill Towers. Our community features apartments with a swimming pool near Cherry Hill Mall, perfect for relaxation.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers offers exceptional living for those seeking apartments with a swimming pool near Cherry Hill Mall. Our community invites you to enjoy a refreshing dip in the pool, situated within easy reach of shopping, dining, and entertainment options. Whether you&#x27;re unwinding after a long day or enjoying a leisurely weekend, our poolside setting provides the perfect escape. Beyond the sparkling swimming pool, Cherry Hill Towers boasts spacious one and two-bedroom apartments designed for comfort and convenience. Here, residents benefit from premium amenities, including a vibrant clubhouse, pet-friendly grounds, and scenic walking trails. Experience the harmony of modern living and serene relaxation at Cherry Hill Towers, nestled in the vibrant Cherry Hill Township.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Swimming Pool Near Cherry Hill Mall",
      "seo_description": "Discover our Cherry Hill Towers apartments, featuring a pool and more amenities, all near Cherry Hill Mall. Dive into comfort and style today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-near-cherry-hill-township-667",
      "search_query": "pet-friendly apartments near Cherry Hill Township",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Cherry Hill Township",
      "h2_subtitle": "Welcome to Cherry Hill Towers, offering pet-friendly living near Cherry Hill Township. Enjoy spacious layouts and pet amenities that cater to your lifestyle.",
      "page_copy": "<p class=\"rteBlock\">Discover the perfect home for you and your furry companions at Cherry Hill Towers, the ideal choice for those seeking pet-friendly apartments near Cherry Hill Township. Our spacious one and two-bedroom floor plans are tailored to accommodate the needs of pet owners, ensuring comfort and convenience for all. The community embraces pet-friendly living with nearby scenic walking trails and a dedicated picnic area. Situated close to the vibrant Cherry Hill Township, Cherry Hill Towers offers a harmonious blend of modern amenities and natural tranquility. Residents benefit from features like on-site management, a swimming pool, and a vibrant clubhouse. Experience a seamless integration of pet-friendly features and an enriching lifestyle at our welcoming community.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Cherry Hill Township",
      "seo_description": "Explore Cherry Hill Towers for spacious and pet-friendly living near Cherry Hill Township. Perfect for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-camden-county-188",
      "search_query": "apartments with air conditioning Camden County",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Camden County",
      "h2_subtitle": "Stay cool at Cherry Hill Towers with air-conditioned apartments. Located in Camden County, our community ensures comfort through all seasons.",
      "page_copy": "At Cherry Hill Towers, we offer modern apartments with air conditioning in Camden County, ensuring a comfortable living experience year-round. Our one and two-bedroom floor plans are designed with your lifestyle in mind, providing a refreshing retreat after a day out in the Cherry Hill Township.\\n\\nResidents of Cherry Hill Towers enjoy a host of conveniences, including a cooling swimming pool, vibrant clubhouse, and beautiful walking trails. Located near the Cherry Hill Mall, our community combines the comforts of air-conditioned living with easy access to shopping and dining. Embrace a lifestyle of convenience and relaxation in our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Air Conditioning in Camden County",
      "seo_description": "Cherry Hill Towers offers air-conditioned apartments in Camden County. Experience year-round comfort and convenience near Cherry Hill Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-cherry-hill-432",
      "search_query": "apartments with in-unit laundry Cherry Hill",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Cherry Hill",
      "h2_subtitle": "Discover the ease of in-unit laundry at Cherry Hill Towers. Located in Cherry Hill, our apartments save you time and offer ultimate convenience.",
      "page_copy": "Cherry Hill Towers is the perfect home for those seeking apartments with in-unit laundry in Cherry Hill. Our modern floor plans feature the convenience of in-unit laundry, making daily chores easier and allowing more time for relaxation and fun. Enjoy the seamless lifestyle that our well-equipped community offers.\\n\\nSituated near Cherry Hill Mall, our community provides easy access to shopping and entertainment while boasting premium amenities such as a swimming pool, pet-friendly spaces, and scenic walking trails. Experience the harmony of modern living paired with convenient in-unit laundry at Cherry Hill Towers, where comfort meets practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with In-Unit Laundry in Cherry Hill",
      "seo_description": "Find convenience at Cherry Hill Towers with in-unit laundry apartments in Cherry Hill. Enjoy easy living near Cherry Hill Mall!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-cherry-hill-nj-980",
      "search_query": "1 bedroom apartments Cherry Hill NJ",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Cherry Hill, NJ",
      "h2_subtitle": "Discover spacious 1 bedroom apartments at Cherry Hill Towers. Located in Cherry Hill, NJ, our community offers modern living and comfort.",
      "page_copy": "<p class=\"rteBlock\">Explore the charm of Cherry Hill Towers, where our 1 bedroom apartments in Cherry Hill, NJ, provide the perfect retreat. Combining comfort and style, these thoughtfully designed spaces cater to your lifestyle needs, complete with premium amenities and modern finishes.Located near the Cherry Hill Mall, residents enjoy easy access to dining, shopping, and entertainment options. Cherry Hill Towers boasts a variety of features, including a swimming pool, pet-friendly areas, and scenic walking trails that enhance the living experience. Choose our 1 bedroom apartments and embrace a vibrant community in Cherry Hill, NJ.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Cherry Hill, NJ",
      "seo_description": "Discover spacious 1 bedroom apartments at Cherry Hill Towers in Cherry Hill, NJ. Enjoy modern living near Cherry Hill Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-cherry-hill-mall-695",
      "search_query": "2 bedroom apartments near Cherry Hill Mall",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Cherry Hill Mall",
      "h2_subtitle": "Find spacious 2 bedroom apartments at Cherry Hill Towers, located just moments away from the vibrant Cherry Hill Mall area.",
      "page_copy": "<p class=\"rteBlock\">Experience the convenience of living near premier shopping and dining with our 2 bedroom apartments near Cherry Hill Mall at Cherry Hill Towers. These spacious homes are perfect for anyone seeking comfort and modern amenities, such as air conditioning and in-unit laundry, that make everyday living a breeze. Residents of Cherry Hill Towers enjoy a host of community amenities, including a refreshing swimming pool, pet-friendly areas, and scenic walking trails. The proximity to Cherry Hill Mall provides easy access to a plethora of retail and entertainment options. Discover your new, vibrant lifestyle with our 2 bedroom apartments in this prime location.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts Near Cherry Hill Mall",
      "seo_description": "Explore 2 bedroom apartments at Cherry Hill Towers, just steps from Cherry Hill Mall. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-cherry-hill-west-high-school-273",
      "search_query": "apartments near Cherry Hill West High School",
      "category": "School",
      "h1_title": "Apartments Near Cherry Hill West High School",
      "h2_subtitle": "Discover the ultimate convenience at Cherry Hill Towers, where our apartments are just a short drive from Cherry Hill West High School.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers provides the perfect living solution for those seeking apartments near Cherry Hill West High School. Nestled in a serene community, our spacious floor plans offer a blend of comfort and modern amenities, ensuring you feel right at home. This ideal location makes daily commutes to school quick and efficient, giving you more time to enjoy family life. Beyond our comfortable interiors, our community features an array of amenities designed to enrich daily living. Enjoy leisure time at our swimming pool, make use of our vibrant clubhouse, or take peaceful strolls along scenic walking trails. Living at Cherry Hill Towers means a balanced lifestyle near Cherry Hill West High School, where convenience meets tranquility.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Cherry Hill West High School",
      "seo_description": "Find comfortable apartments at Cherry Hill Towers, located near Cherry Hill West High School. Enjoy convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "rentals-near-carusi-middle-school-cherry-hill-117",
      "search_query": "Cherry Hill Township rentals close to Carusi Middle School",
      "category": "School",
      "h1_title": "Rentals Near Carusi Middle School",
      "h2_subtitle": "Explore Cherry Hill Township rentals at Cherry Hill Towers, just minutes from Carusi Middle School, offering convenience and comfort.",
      "page_copy": "<p class=\"rteBlock\">Discover the ease of renting at Cherry Hill Towers, located in Cherry Hill Township and conveniently close to Carusi Middle School. These comfortable and modern rentals provide spacious floor plans tailored to meet the needs of families and individuals alike, all within a community-focused environment.Residents enjoy a range of amenities including a swimming pool and pet-friendly spaces, making it more than just a place to live but a community to thrive in. Proximity to Carusi Middle School ensures stress-free commutes and more time for family, while nearby shopping and dining options contribute to a well-rounded lifestyle right here in Cherry Hill Township.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cherry Hill Rentals Near Carusi Middle School",
      "seo_description": "Find rentals at Cherry Hill Towers, near Carusi Middle School. Enjoy family-friendly living in Cherry Hill Township.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-joyce-kilmer-elementary-08002-400",
      "search_query": "apartments near Joyce Kilmer Elementary School in 08002",
      "category": "School",
      "h1_title": "Apartments Near Joyce Kilmer Elementary",
      "h2_subtitle": "Cherry Hill Towers offers ideal apartments near Joyce Kilmer Elementary School, perfect for families in the 08002 area.",
      "page_copy": "<p class=\"rteBlock\">Welcome to Cherry Hill Towers, where you can find spacious apartments near Joyce Kilmer Elementary School, perfect for families looking to settle in the 08002 area. Enjoy the convenience of living in a community that puts education and family first, with easy access to the school and other community amenities. Our community features include a refreshing swimming pool and family-friendly picnic areas, enhancing the allure of Cherry Hill living. Located in a prime neighborhood, Cherry Hill Towers offers a perfect blend of comfort and accessibility, ensuring all the conveniences and necessities are within reach. Make your move to a community that supports a balanced lifestyle.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Joyce Kilmer Elementary in 08002",
      "seo_description": "Discover Cherry Hill Towers' family-friendly apartments near Joyce Kilmer Elementary School, located in the heart of the 08002 area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "properties-near-clara-barton-elementary-nj-893",
      "search_query": "properties close to Clara Barton Elementary School NJ",
      "category": "School",
      "h1_title": "Properties Near Clara Barton Elementary",
      "h2_subtitle": "Find desirable properties near Clara Barton Elementary School at Cherry Hill Towers, NJ, ideal for growing families.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers offers a selection of properties close to Clara Barton Elementary School, NJ, providing an ideal setting for families prioritizing education and convenience. Our community, nestled in the heart of Cherry Hill, features spacious living options surrounded by greenspace and modern amenities. Enjoy a family-friendly atmosphere with amenities like a vibrant clubhouse and scenic walking trails. From the comfort of Cherry Hill Towers, commuting to Clara Barton Elementary School is a breeze, allowing for more family time and less travel stress. Choose a home that caters to convenience and modern living, right here in NJ.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Near Clara Barton Elementary NJ",
      "seo_description": "Explore properties at Cherry Hill Towers, near Clara Barton Elementary, offering modern living in NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "cherry-hill-rentals-near-rosa-international-ms-969",
      "search_query": "Cherry Hill rentals near Rosa International Middle School",
      "category": "School",
      "h1_title": "Cherry Hill Rentals Near Rosa International",
      "h2_subtitle": "Explore Cherry Hill rentals conveniently located near Rosa International Middle School for easy commutes and family-friendly amenities.",
      "page_copy": "Discover the perfect Cherry Hill rentals at Cherry Hill Towers, situated just moments from Rosa International Middle School. Enjoy a seamless blend of convenience and quality living in a community designed with families in mind. These rentals provide an ideal location for those who value proximity to top-notch schools and essential everyday amenities.\\n\\nWith ample space, modern design, and a variety of community features such as a refreshing swimming pool and pet-friendly areas, Cherry Hill Towers offers an exceptional living experience. Positioned near Rosa International Middle, our community ensures easy commutes and proximity to local attractions, enhancing the overall quality of life for residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cherry Hill Rentals by Rosa International School",
      "seo_description": "Find Cherry Hill rentals at Cherry Hill Towers, located near Rosa International Middle School, equipped with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "camden-county-apartments-near-politz-day-school-298",
      "search_query": "Camden County apartments near Politz Day School",
      "category": "School",
      "h1_title": "Camden County Apartments by Politz Day School",
      "h2_subtitle": "Discover Camden County apartments conveniently located near Politz Day School, perfect for families seeking convenience and quality living.",
      "page_copy": "<p class=\"rteBlock\">Welcome to Cherry Hill Towers, where you can find prime Camden County apartments near Politz Day School. Located in a serene setting, our community provides the ideal balance of convenience and comfort for families pursuing quality education and amenities. With spacious floor plans and modern features, Cherry Hill Towers offers everything you need for a vibrant lifestyle. Enjoy our community amenities, including a dynamic clubhouse and scenic walking trails, while being just a short distance from Politz Day School. Experience the best of Camden County living, where education and lifestyle seamlessly come together.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Camden County Apts Near Politz Day School",
      "seo_description": "Find Camden County apartments at Cherry Hill Towers near Politz Day School, perfect for families prioritizing convenience and education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-cherry-hill-hospital-nj-934",
      "search_query": "apartments near Jefferson Cherry Hill Hospital NJ",
      "category": "Hospital",
      "h1_title": "Apartments Near Jefferson Cherry Hill Hospital",
      "h2_subtitle": "Explore apartments conveniently located near Jefferson Cherry Hill Hospital, NJ, ideal for medical professionals and families.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers presents premium living options for those seeking apartments near Jefferson Cherry Hill Hospital, NJ. Our community offers a perfect blend of tranquility and convenience, ideal for healthcare professionals and families needing proximity to essential services. Boasting spacious one and two-bedroom layouts, Cherry Hill Towers provides residents with both comfort and practicality. Embrace the benefits of modern amenities like a vibrant clubhouse, alongside easy access to Jefferson Cherry Hill Hospital, ensuring that work-life balance is effortlessly achieved.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Jefferson Cherry Hill Hospital NJ",
      "seo_description": "Discover Cherry Hill Towers' apartments near Jefferson Cherry Hill Hospital, NJ, perfect for professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "cherry-hill-mall-apartments-near-virtua-voorhees-807",
      "search_query": "Cherry Hill Mall apartments close to Virtua Voorhees Hospital",
      "category": "Hospital",
      "h1_title": "Cherry Hill Mall Apts Near Virtua Voorhees Hospital",
      "h2_subtitle": "Find Cherry Hill Mall apartments conveniently located close to Virtua Voorhees Hospital, merging comfort and accessibility.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers offers exceptional living with its Cherry Hill Mall apartments positioned close to Virtua Voorhees Hospital. Perfectly situated for both medical professionals and those seeking a vibrant community lifestyle, our location ensures you’re never far from where you need to be. Offering modern, spacious floor plans with premium features, Cherry Hill Towers stands out with its array of amenities, including a scenic walking trail and a pet-friendly environment. Enjoy the convenience of living near top-tier hospital facilities while relishing the tranquility of a resort-style community.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cherry Hill Mall Apts Near Virtua Voorhees",
      "seo_description": "Discover Cherry Hill Towers' proximity to Virtua Voorhees Hospital with our Cherry Hill Mall apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-cooper-river-park-camden-county-933",
      "search_query": "apartments near Cooper River Park Camden County",
      "category": "Park",
      "h1_title": "Apts Near Cooper River Park, Camden County",
      "h2_subtitle": "Discover apartments near Cooper River Park in Camden County. Our community offers comfort and convenience for outdoor enthusiasts.",
      "page_copy": "<p class=\"rteBlock\">Welcome to Cherry Hill Towers, featuring remarkable apartments near Cooper River Park, Camden County. Perfect for those who love the outdoors, our location offers easy access to the expansive park, ideal for weekend picnics, morning jogs, or leisurely strolls. Cherry Hill Towers provides comfortable living with its spacious one and two-bedroom options, enhanced by modern amenities like a refreshing swimming pool. Enjoy the tranquility of nature while being part of a vibrant, pet-friendly community that ensures both relaxation and adventure are just steps away from your door.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Cooper River Park in Camden County",
      "seo_description": "Find Cherry Hill Towers' apts near Cooper River Park in Camden County, perfect for outdoor lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "rentals-close-to-croft-farm-cherry-hill-21",
      "search_query": "rentals close to Croft Farm Cherry Hill Township",
      "category": "Park",
      "h1_title": "Rentals Near Croft Farm, Cherry Hill Township",
      "h2_subtitle": "Explore rentals close to Croft Farm in Cherry Hill Township. Enjoy convenience and a vibrant community lifestyle.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers offers the perfect rentals close to Croft Farm in Cherry Hill Township, ideal for those seeking comfort and convenience. Embrace the unique mix of cultural events and outdoor activities at Croft Farm while enjoying the luxury of modern living at our community. Our spacious one and two-bedroom floor plans cater to varied lifestyles, complemented by superior amenities like a vibrant clubhouse and on-site management. Whether you’re an adventure enthusiast or enjoy a relaxed lifestyle, Cherry Hill Towers places you at the heart of it all, with Croft Farm just moments away.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Croft Farm, Cherry Hill Township",
      "seo_description": "Discover Cherry Hill Towers' rentals near Croft Farm, Cherry Hill Township, blending convenience and charm.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "living-by-challenge-grove-park-nj-725",
      "search_query": "living by Challenge Grove Park NJ",
      "category": "Park",
      "h1_title": "Living by Challenge Grove Park, NJ",
      "h2_subtitle": "Experience the benefits of living by Challenge Grove Park, NJ. Discover the perfect blend of nature and luxury.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers provides an exceptional living experience by Challenge Grove Park, NJ. Nestled in a serene environment, our community combines the tranquility of nature with the luxury of modern amenities. Residents enjoy easy access to the park&#x27;s beautiful walking trails and recreational facilities, making it an ideal spot for nature lovers and outdoor enthusiasts. Our spacious and stylish one and two-bedroom apartments offer premium features that cater to your lifestyle. With amenities like a refreshing swimming pool and a pet-friendly atmosphere, Cherry Hill Towers ensures a harmonious balance of comfort and adventure. Live conveniently near Challenge Grove Park and explore all that our community has to offer.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Challenge Grove Park, NJ",
      "seo_description": "Explore the perks of living by Challenge Grove Park, NJ at Cherry Hill Towers, merging nature with luxury.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-wallworth-pond-cherry-hill-mall-207",
      "search_query": "apartments near Wallworth Pond Cherry Hill Mall",
      "category": "Park",
      "h1_title": "Apts Near Wallworth Pond, Cherry Hill Mall",
      "h2_subtitle": "Find serene apartments near Wallworth Pond by Cherry Hill Mall. Enjoy a balanced lifestyle with nature and convenience.",
      "page_copy": "<p class=\"rteBlock\">Discover Cherry Hill Towers, where you can find apartments near Wallworth Pond, just a stone&#x27;s throw from Cherry Hill Mall. Our community offers a peaceful retreat accompanied by the excitement of shopping and dining options at the nearby mall. Residents enjoy spacious one and two-bedroom layouts designed with your comfort in mind. Relax at our refreshing swimming pool or take a stroll around Wallworth Pond. Cherry Hill Towers delivers an unmatched living experience with its prime location, bringing nature and convenience together beautifully.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Wallworth Pond, Cherry Hill Mall",
      "seo_description": "Find Cherry Hill Towers' apts near Wallworth Pond and Cherry Hill Mall, a perfect blend of tranquility and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "rentals-by-lions-den-park-camden-county-582",
      "search_query": "rentals by Lion's Den Park Camden County",
      "category": "Park",
      "h1_title": "Rentals by Lion's Den Park, Camden County",
      "h2_subtitle": "Explore exceptional rentals by Lion's Den Park in Camden County. Experience a vibrant and convenient lifestyle.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers introduces you to ideal rentals by Lion&#x27;s Den Park, situated in the vibrant Camden County. Our community offers a prime location blending luxury living with natural beauty. Just moments away from Lion&#x27;s Den Park, enjoy a plethora of outdoor activities and recreational spaces. Our spacious one and two-bedroom apartments are designed for comfort and style. With premium amenities like a vibrant clubhouse and pet-friendly policies, Cherry Hill Towers is perfect for those wanting a balanced and active lifestyle. Enjoy seamless access to Lion&#x27;s Den Park while relishing the community&#x27;s serene environment.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Lion's Den Park, Camden County",
      "seo_description": "Discover rentals by Lion's Den Park, Camden County at Cherry Hill Towers, offering luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "cherry-valley-park-nearby-apartments-08002-342",
      "search_query": "Cherry Valley Park nearby apartments 08002",
      "category": "Park",
      "h1_title": "Cherry Valley Park Nearby Apartments 08002",
      "h2_subtitle": "Explore Cherry Valley Park nearby apartments in 08002. Discover the convenience and luxury of living close to nature.",
      "page_copy": "<p class=\"rteBlock\">Located in the vibrant 08002 area, Cherry Hill Towers offers luxurious apartments near Cherry Valley Park. Enjoy the natural beauty and outdoor fun that comes with being close to this scenic park. Our community provides the ideal living environment with spacious one and two-bedroom layouts that cater to all lifestyles. With premium amenities such as a relaxing pool, on-site management, and garages, Cherry Hill Towers ensures a convenient and comfortable experience. The proximity to Cherry Valley Park allows for easy access to leisure and recreation, perfect for nature lovers. Discover the harmony of modern living and nature with our nearby apartments.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cherry Valley Park Nearby Apartments 08002",
      "seo_description": "Discover Cherry Hill Towers' apartments near Cherry Valley Park in 08002, offering luxury and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "erlton-school-park-apartments-cherry-hill-nj-987",
      "search_query": "Erlton School Park apartments in Cherry Hill NJ",
      "category": "Park",
      "h1_title": "Erlton School Park Apartments in Cherry Hill NJ",
      "h2_subtitle": "Discover Erlton School Park apartments in Cherry Hill, NJ. Enjoy a community that blends convenience with natural charm.",
      "page_copy": "<p class=\"rteBlock\">At Cherry Hill Towers, you&#x27;ll find exquisite apartments near Erlton School Park in Cherry Hill, NJ. Our community combines modern amenities with the tranquility of nature, ideally situated for those who value convenience and relaxation. Enjoy easy access to the park, perfect for leisurely walks and outdoor activities. Our spacious one and two-bedroom apartments provide a comfortable retreat, complete with features like a refreshing pool and vibrant clubhouse. Embrace pet-friendly living and take advantage of available garages. Cherry Hill Towers offers everything you need for a perfect lifestyle close to Erlton School Park.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Erlton School Park Apartments, Cherry Hill NJ",
      "seo_description": "Explore Cherry Hill Towers' apartments near Erlton School Park in Cherry Hill, NJ, merging luxury living with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-near-woodcrest-station-cherry-hill-nj-529",
      "search_query": "apartments near Woodcrest Station Cherry Hill NJ",
      "category": "Transit",
      "h1_title": "Apartments Near Woodcrest Station, Cherry Hill NJ",
      "h2_subtitle": "Find premium apartments near Woodcrest Station in Cherry Hill, NJ. Enjoy an unparalleled lifestyle of convenience and comfort.",
      "page_copy": "<p class=\"rteBlock\">Cherry Hill Towers offers exceptional apartments near Woodcrest Station, Cherry Hill, NJ. Ideally situated for commuters, our community provides easy access to public transportation, making it simple to connect with the surrounding area. Experience the comfort of spacious one and two-bedroom layouts in a vibrant and inviting setting. Our community is rich with amenities, including a picturesque picnic area and a vibrant clubhouse. Pet-friendly policies ensure that your furry companions are welcome too. Discover the convenience of living close to Woodcrest Station, combined with the luxury of Cherry Hill Towers, a blend of modern amenities and natural charm.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodcrest Station, Cherry Hill NJ",
      "seo_description": "Discover Cherry Hill Towers' luxury apartments near Woodcrest Station in Cherry Hill, NJ, offering unmatched convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166312",
      "source": "custom",
      "page_item_url": "apartments-close-route-73-pennsauken-camden-co-543",
      "search_query": "apartments close to Route 73/Pennsauken Camden County",
      "category": "Transit",
      "h1_title": "Apartments Close to Route 73/Pennsauken Area",
      "h2_subtitle": "Explore apartments close to Route 73 and Pennsauken in Camden County. Enjoy easy commuting and luxury amenities.",
      "page_copy": "<p class=\"rteBlock\">Positioned conveniently near Route 73 and the Pennsauken area in Camden County, Cherry Hill Towers offers luxurious living spaces. Our apartments provide excellent access to major roadways for a smooth daily commute. Ideal for those looking for the perfect balance of accessibility and comfort. Residents can delight in our vast array of amenities, including refreshing swimming pools and scenic walking trails. The pet-friendly community also features on-site management and available garages, enhancing the lifestyle experience. Discover the benefits of living close to Route 73 and Pennsauken while enjoying modern conveniences at Cherry Hill Towers.</p>",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
      "featured_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and tennis courts in the background.",
        "public_id": "01a015d9-6721-751b-8a11-a9d04c476b12",
        "storage_key": "property/6767906449166312/01a015d9-6721-751b-8a11-a9d04c476b12.webp",
        "width": 2939,
        "height": 2221
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Route 73/Pennsauken",
      "seo_description": "Discover Cherry Hill Towers' apartments near Route 73 and Pennsauken in Camden County, offering luxury and seamless commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5050"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976236527"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973270"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MGXP9PPK"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livecherryhilltowers.fatwin.com/api/websites/resources/1?x=ak85Vis0NDRCZVI5QVltNWJOZUhzTGRwNFE5aXlSa2xKdEtsd1prdTZ4SnhCb2kzelBmT2Z6bE1GS2lQT29RQk8wR2ZTYWVXdFUwVXNLaytZVWNTTXc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Stadium House"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwjq3qjv1e"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549b05a-43e6-11ef-8608-338aad7605ef"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b05a-43e6-11ef-8608-338aad7605ef/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b05a-43e6-11ef-8608-338aad7605ef/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkpaNFBURzR5ekUrc253dmFyRVRMeGc9PSIsInZhbHVlIjoienlOcFZKbVFHTHhIR2tFYkcxMVJqZz09IiwibWFjIjoiYzJkZmRiNzQ5YjU2OGQ1MWU3YzM5NGY2ZTdjYzk0YWJmZjY4OTFmM2VlZWMzZmU3YTM2ZWFiNTU2ZGFjZTU3MiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5050",
  "custom_repli_id": "9976236527",
  "custom_realpage_id": "4973270",
  "custom_google_gtm_id": "GTM-MGXP9PPK",
  "custom_perq_script_url": "https://livecherryhilltowers.fatwin.com/api/websites/resources/1?x=ak85Vis0NDRCZVI5QVltNWJOZUhzTGRwNFE5aXlSa2xKdEtsd1prdTZ4SnhCb2kzelBmT2Z6bE1GS2lQT29RQk8wR2ZTYWVXdFUwVXNLaytZVWNTTXc9PQ2",
  "custom_vibesites_theme": "Stadium House",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rxwjq3qjv1e",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549b05a-43e6-11ef-8608-338aad7605ef",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b05a-43e6-11ef-8608-338aad7605ef/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b05a-43e6-11ef-8608-338aad7605ef/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkpaNFBURzR5ekUrc253dmFyRVRMeGc9PSIsInZhbHVlIjoienlOcFZKbVFHTHhIR2tFYkcxMVJqZz09IiwibWFjIjoiYzJkZmRiNzQ5YjU2OGQ1MWU3YzM5NGY2ZTdjYzk0YWJmZjY4OTFmM2VlZWMzZmU3YTM2ZWFiNTU2ZGFjZTU3MiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "c9a8a15e-c8f4-490f-9796-2fb003fd5b48",
  "custom_audioeye_site_hash": "3aab44978a2fc5bc2665bcca968b7a14"
};

export const generatedAt = '2026-10-22T20:05:02.798Z';
